
const translations = {
    "Notice!": "Aviso!",
    "Are you sure that you want to delete this?": "¿Está seguro de que quiere borrar esto?",
    "Confirm": "Confirmar",
    "Cancel": "Cancelar",
    "Min": "Mín",
    "Max": "Máx",
    "Before": "Antes",
    "After": "Después",
    "w": "w",
    "week": "semana",
    "weeks": "semanas",
    "d": "d",
    "day": "día",
    "days": "dias",
    "Due date": "Fecha límite",
    "Start date": "Fecha de inicio",
    "Internal date": "Fecha interna",
    "Notes": "Notas",
    "Document": "Documento",
    "Email": "Email",
    "Billing": "Facturación",
    "Add": "Añadir",
    "Archived": "Archivado",
    "Cancelled": "Cancelado",
    "Active": "Activo",
    "Inactive": "Inactivo",
    "Client company": "Empresa cliente",
    "General info": "Información general",
    "Digitisation of client documents": "Digitalización de documentos de clientes",
    "Client portal": "Portal del cliente",
    "Documents": "Documentos",
    "Members": "Miembros",
    "Preferences": "Preferencias",
    "Yes": "Sí",
    "No": "No",
    "Total hours": "Total de horas",
    "Extra hours": "Horas extra",
    "Client": "Cliente",
    "Tasks": "Tareas",
    "Disable Uku’s task templates": "Desactivar las plantillas de tareas de Uku",
    "Set the estimation as time when the exact value is not entered": "Establezca la estimación como tiempo cuando no se introduzca el valor exacto",
    "Checklist must be completed to finish the task": "La lista de comprobación debe completarse para finalizar la tarea",
    "Disable topic management for members": "Desactivar la gestión de temas para los miembros",
    "Disable time edit for members": "Desactivar la edición de tiempo para los miembros",
    "Allow time entries in future": "Permitir entradas de tiempo en el futuro",
    "Show all dependent tasks in the calendar": "Mostrar todas las tareas dependientes en el calendario",
    "Clients": "Clientes",
    "Disable adding new clients for members": "Desactivar la adición de nuevos clientes para los miembros",
    "Only administrators can edit documents": "Sólo los administradores pueden editar documentos",
    "Allow digitisation of client documents": "Permitir la digitalización de los documentos de los clientes",
    "Use my Microsoft account": "Utilizar mi cuenta Microsoft",
    "Disconnect my Microsoft account": "Desconectar mi cuenta Microsoft",
    "Connect my Microsoft account": "Conectar mi cuenta Microsoft",
    "Use my google account": "Utilizar mi cuenta de google",
    "Connect my google account": "Conectar mi cuenta de google",
    "Disconnect my google account": "Desconectar mi cuenta de google",
    "Use my Xero account": "Usar mi cuenta de Xero",
    "Connect my Xero account": "Conectar mi cuenta de Xero",
    "Disconnect my Xero account": "Desconectar mi cuenta de Xero",
    "Emails": "Emails",
    "Daily agenda": "Agenda diaria",
    "Unread notifications": "Notificaciones no leídas",
    "Task assigned to me": "Tarea asignada",
    "Weekly summary": "Resumen semanal",
    "Monthly summary": "Resumen mensual",
    "Updates and tips": "Actualizaciones y consejos",
    "Overdue": "Atrasado",
    "1 day": "1 día",
    "1 day overdue": "1 día de retraso",
    "{0} days": "{0} dias",
    "{0} days overdue": "{0} días de retraso",
    "{0} minute ago": "{0} hace un minuto",
    "{0} minutes ago": "hace {0} minutos",
    "{0} hour ago": "{0} hace una hora",
    "{0} hours ago": "hace {0} horas",
    "Sunday": "Domingo",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "Sun": "Dom",
    "Mon": "Lun",
    "Tue": "Mar",
    "Wed": "Mie",
    "Thu": "Jue",
    "Fri": "Vie",
    "Sat": "Sab",
    "January": "Enero",
    "February": "Febrero",
    "March": "Marzo",
    "April": "Abril",
    "May": "Mayo",
    "June": "Junio",
    "July": "Julio",
    "August": "Agosto",
    "September": "Septiembre",
    "October": "Octubre",
    "November": "Noviembre",
    "December": "Diciembre",
    "Jan": "Ene",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Abr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ago",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dic",
    "Today": "Hoy",
    "Yesterday": "Ayer",
    "Day": "Día",
    "Days": "Días",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Semanal {0}",
    "Every {0}. week {1}": "Cada {0}. semana {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Mensual {0}. d",
    "Every {0}. month {1}. d": "Cada {0}. mes {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Trimestral {0}. mes {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Cada {0}. trimestre {1}. mes {2}. d",
    "{0}. month {1}. d": "{0}. mes {1}. d",
    "Yearly {0}": "Anual {0}",
    "Every {0}. year {1}": "Cada {0}. año {1}",
    "Mo": "Lu",
    "Tu": "Ma",
    "We": "Mi",
    "Th": "Ju",
    "Fr": "Vie",
    "Sa": "Sa",
    "Su": "Do",
    "and": "y",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "antes",
    "after": "después",
    "Project": "Proyecto",
    "Quarter": "Trimestre",
    "Add logo": "Añadir logo",
    "Add your photo": "Añada su foto",
    "Adding file failed": "Fallo al añadir el archivo",
    "Please check the file.": "Por favor, compruebe el archivo.",
    "You can only add pictures.": "Sólo puede añadir imágenes.",
    "Error": "Error",
    "Create new topic": "Crear un nuevo tema",
    "Name": "Nombre",
    "Close": "Cerrar",
    "Find topic...": "Buscar tema...",
    "New topic": "Nuevo tema",
    "Invalid format": "Formato no válido",
    "Demo company account": "Cuenta demo de empresa",
    "Demo account will be deleted later. Do this for testing purposes only!": "La cuenta de demostración se eliminará más adelante. ¡Hágalo sólo con fines de prueba!",
    "Subscribe": "Suscribirse",
    "Start demo": "Iniciar demostración",
    "End demo": "Fin de la demostración",
    "Free trial is expired - {0}": "La prueba gratuita ha caducado - {0}",
    "Free trial {1} {2} left - {0}": "Prueba gratuita {1} {2} izquierda - {0}",
    "Add time": "Añadir tiempo",
    "Billable": "Facturable",
    "Date": "Fecha",
    "Start": "Inicio",
    "End": "Fin",
    "Duration": "Duración",
    "Split duration equally": "Dividir la duración a partes iguales",
    "Required field": "Campo obligatorio",
    "Members list": "Lista de miembros",
    "Edit fields": "Campos de edición",
    "Maximum number of selected columns has been exceeded": "Se ha superado el número máximo de columnas seleccionadas",
    "If you want to add a new column to the report, please remove an existing one first.": "Si desea añadir una nueva columna al informe, elimine primero una existente.",
    "Snooze until...": "Snooze hasta...",
    "Select date & time": "Seleccionar fecha y hora",
    "Tomorrow": "Mañana",
    "Later this week": "A finales de esta semana",
    "Next week": "Próxima semana",
    "Add task": "Añadir tarea",
    "Checklist": "Checklist",
    "Start timer": "Iniciar temporizador",
    "Add an item": "Añadir item",
    "Add checklist item": "Añadir elemento a la lista de control",
    "Convert to a task": "Convertir en una tarea",
    "Delete": "Borrar",
    "Delegate to...": "Delegue en...",
    "Please select tasks from the same account": "Seleccione tareas de la misma cuenta",
    "Follow": "Seguir",
    "Expand sidebar": "Ampliar la barra lateral",
    "Nicely done!": "¡Bien hecho!",
    "You've finished all your tasks, take a second to recharge": "Ha terminado todas sus tareas, tómese un segundo para recargarse",
    "Search tasks...": "Buscar tareas...",
    "Search": "Buscar",
    "select/unselect all": "seleccionar/deseleccionar todo",
    "Add new client": "Agregar otro cliente ",
    "Account": "Cuenta",
    "Client name": "Nombre del cliente",
    "Select client": "Seleccionar cliente",
    "New client": "Nuevo cliente",
    "Must be an integer": "Debe ser un número entero",
    "Must be a number": "Debe ser un número",
    "Dashboard": "Escritorio",
    "Calendar": "Calendario",
    "Report": "Informe",
    "Monitoring": "Monitorización",
    "Suppliers": "Proveedores",
    "Events": "Eventos",
    "Projects": "Proyectos",
    "Help": "Ayuda",
    "Invite a friend": "Invite a un amigo",
    "Settings & Apps": "Ajustes y aplicaciones",
    "Profile": "Perfil",
    "Collapse menu": "Contraer Menú",
    "Expand menu": "Expandir menú",
    "Are you sure to delete this attachment?": "¿Está seguro de borrar este archivo adjunto?",
    "Select": "Seleccionar",
    "Edit contacts": "Editar contactos",
    "Add member": "Añadir miembro",
    "Add note": "Añadir nota",
    "Open": "Abierto",
    "Reports": "Informes",
    "Billing notes": "Notas de facturación",
    "Pinned notes": "Notas ancladas",
    "Sub-companies": "Subempresas",
    "Contacts": "Contactos",
    "Event info": "Información del evento",
    "Project info": "Información de programa",
    "Summary": "Resumen",
    "Task": "Tarea",
    "Time": "Hora",
    "Collapse sidebar": "Colapsar barra lateral",
    "Client Overview": "Visión general del cliente",
    "Event Overview": "Descripción general del evento",
    "Project Overview": "Descripción del proceso",
    "Edit client": "Editar cliente",
    "Edit event": "Editar evento",
    "Edit project": "Editar proyecto",
    "Show all": "Mostrar todo",
    "Collapse": "Colapsar",
    "by": "por",
    "View all": "Ver todo",
    "Copied to clipboard": "Copiado al portapapeles",
    "Client portal invite sent on {0}": "Invitación al portal del cliente enviada el {0}",
    "Client portal invite has not been sent": "La invitación al portal del cliente no se ha enviado",
    "Resend invite": "Reenviar invitación",
    "Send invite": "Enviar invitación",
    "Invite sent": "Invitar Compañero",
    "Add company event": "Añadir evento de empresa",
    "Company": "Empresa",
    "Info": "Información",
    "Holiday": "Feriado",
    "All day(s)": "Todos los días",
    "End date": "Fecha de finalización",
    "From": "Desde",
    "Until": "Hasta el",
    "Hours": "Horas",
    "Link": "Enlace",
    "Save": "Guardar",
    "Are you sure that you want to delete this company calendar event?": "¿Está seguro de que desea eliminar este evento del calendario de empresa?",
    "Location of client folder in your document management system": "Ubicación de la carpeta del cliente en su sistema de gestión de documentos",
    "Defined main folder": "Carpeta principal definida",
    "Custom folder": "Carpeta personalizada",
    "Add new role": "Añadir nuevo rol",
    "New role": "Nuevo rol",
    "Access enabled": "Acceso habilitado",
    "Waiting for files": "A la espera de los archivos",
    "Uploaded": "Subido",
    "Uploading...": "Subiendo...",
    "Client members": "Miembros clientes",
    "Email settings": "Ajustes de email",
    "Or connect new email address": "O conecte una nueva dirección de correo electrónico",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Conectar con Microsoft Exchange u otro servidor de correo electrónico (SMTP)",
    "Test email sent": "Correo electrónico de prueba enviado",
    "Email address": "Dirección de correo electrónico",
    "Reply address": "Dirección de respuesta",
    "Sender name": "Nombre del remitente",
    "Who can use?": "¿Quién puede utilizarlo?",
    "Client default address": "Dirección predeterminada del cliente",
    "Invalid e-mail": "Correo electrónico no válido",
    "Role": "Rol",
    "E-mail": "E-mail",
    "Mobile phone": "Teléfono móvil",
    "Work phone": "Teléfono del trabajo",
    "Language": "Idioma",
    "Birthday": "Cumpleaños",
    "Are you sure to delete this contact?": "¿Está seguro de eliminar este contacto?",
    "Manage contact fields": "Gestionar los campos de contacto",
    "Administrative Assistant": "Asistente de administración",
    "Board member": "Miembro del consejo",
    "CEO": "Ceo",
    "Add contact": "Añadir contacto",
    "Contact person": "Persona contacto",
    "Leave page?": "¿Dejar la página?",
    "Changes that you made may not be saved": "Es posible que no se guarden los cambios realizados",
    "Leave": "Salir",
    "Validate tasks": "Validar tareas",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "El contacto que intentas eliminar es un usuario asignado en {0} tareas. Elimina el contacto de las tareas para continuar.",
    "Continue": "Continuar",
    "Super! We're importing your clients...": "¡Súper! Estamos importando a sus clientes...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "No dude en abandonar esta página. Le enviaremos una notificación cuando la importación esté preparada. A continuación, deberá confirmar los clientes que desea añadir a Uku.",
    "Please wait...": "Por favor espera...",
    "Setup API keys": "Configurar claves API",
    "You have two options": "Tiene dos opciones",
    "how to setup API keys": "cómo configurar las claves API",
    "Custom import": "Importación personalizada",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Para importar clientes y volumen de trabajo de !INTEGRATION, Uku necesita la clave API de !INTEGRATION para cada cliente.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Continuar</span> - Uku crea automáticamente claves API para cada cliente",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Importación personalizada</span> - Uku se conecta sólo con claves API UKU existentes. Cree las claves API manualmente en !INTEGRATION antes de la importación. Lea:",
    "(it takes a lot of time)": "(lleva mucho tiempo)",
    "Import Clients": "Importar clientes",
    "Country": "País",
    "Please choose your country": "Por favor, elija su país",
    "Password": "Contraseña",
    "Start import": "Iniciar Importación",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Introduzca los datos de acceso de !INTEGRATION (es seguro) para acceder una sola vez a los clientes de importación y a las claves API. Tenga en cuenta que saldrá de !INTEGRATION en otros navegadores.",
    "Update invoice status": "Actualizar el estado de la factura",
    "Update now": "Actualizar ahora",
    "Daily @ 14:00": "Todos los días a las 14:00",
    "Daily @ 18:00": "Todos los días a las 18:00",
    "Updating invoice statuses, please wait...": "Actualizando estados de facturas, por favor espere...",
    "Your import is ready": "Su importación está lista",
    "In the final step you need to confirm the clients you want to add to uku": "En el último paso debe confirmar los clientes que desea añadir a uku",
    "Let's go": "¡Listo!",
    "Import again": "Importar de nuevo",
    "Do you have new clients to import?": "¿Tiene nuevos clientes que importar?",
    "Yes, i do": "Sí, quiero",
    "View last import": "Ver la última importación",
    "Email server": "Servidor de correo electrónico",
    "Email provider": "Correo proveedor",
    "Host": "Host",
    "Port": "Puerto",
    "Security": "Seguridad",
    "Sender email": "Correo del Remitente",
    "Username": "Nombre de usuario",
    "Test connection": "Probar conexión",
    "How to set up": "Cómo instalar",
    "Only administrators can activate the app": "Sólo los administradores pueden activar la aplicación",
    "You are in the waiting list": "Está en lista de espera",
    "We onboard all applicants one by one": "Embarcamos a todos los solicitantes uno por uno",
    "Connected": "Conectado",
    "Activated": "Activado",
    "Join waiting list": "Apuntarse a la lista de espera",
    "Activate": "Activar",
    "Unsubscribe from waiting list": "Darse de baja de la lista de espera",
    "Deactivate app": "Desactivar la aplicación",
    "Disconnect": "Desconectar",
    "Hide expanded content": "Ocultar contenido ampliado",
    "Show trimmed content": "Mostrar contenido recortado",
    "Email not delivered": "Correo electrónico no entregado",
    "Sent, but fallback to Uku email": "Enviado, pero vuelve al correo electrónico de Uku",
    "Unknown error": "Error desconocido",
    "to": "a",
    "automatically": "automáticamente",
    "in any minute": "en cualquier momento",
    "on {0},": "en {0},",
    "or": "o",
    "Send now": "Enviar ahora",
    "Uku will no longer send email": "Uku ya no enviará correos electrónicos",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>está enviando</span> correo electrónico",
    "__From_email": "__De_email",
    "Set up email": "Configurar el correo electrónico",
    "Client default": "Cliente por defecto",
    "Subject": "Tema",
    "Edit email": "Editar email",
    "Template": "Plantilla",
    "Cc": "Cc",
    "Bcc": "Bcc",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Añadir plantilla",
    "Add automation": "Añadir automatización",
    "Add placeholder": "Añadir marcador de posición",
    "Format text": "Formatear texto",
    "Add attachment": "Añadir un adjunto",
    "Send": "Enviar",
    "Save automation": "Ahorrar automatización",
    "Choose email template": "Elija la plantilla de correo electrónico",
    "All languages": "Todos los idiomas",
    "No templates found.": "No se han encontrado plantillas.",
    "Edit email template": "Editar plantilla de email",
    "Are you sure you want to delete this template? Some tasks will be affected": "¿Está seguro de que desea eliminar esta plantilla? Algunas tareas se verán afectadas",
    "Are you sure you want to delete this template?": "¿Estás seguro de que quieres borrar los ajustes de tu sitio?",
    "Are you sure you want to save this template, the following tasks will be affected?": "¿Está seguro de que desea guardar esta plantilla, las siguientes tareas se verán afectadas?",
    "Template name": "Nombre de la plantilla",
    "Edit template": "Editar plantilla",
    "Send email": "Enviar email",
    "on": "en",
    "Ok": "Ok",
    "Supplier": "Proveedor",
    "Event": "Evento",
    "Contact": "Contacto",
    "Validation failed": "Validación fallida",
    "Saving supplier failed": "Error al guardar el proveedor",
    "Saving client failed": "Error al guardar el cliente",
    "Saving project failed": "Falla al guardar el proyecto",
    "several values": "varios valores",
    "values": "valores",
    "is": "es",
    "Add filter": "Añadir filtro",
    "Update": "Actualizar",
    "forever": "para siempre",
    "Last week": "La semana pasada",
    "This week": "Esta semana",
    "Last month": "Último mes",
    "This month": "Este mes",
    "Next month": "Mes siguiente",
    "Last year": "El año pasado",
    "This year": "Este año",
    "This quarter": "Hace 4 meses",
    "Next quarter": "Próximo trimestre",
    "Last quarter": "Hace 4 meses",
    "Client group": "Grupo de clientes",
    "Topic": "Tema",
    "Member": "Miembro",
    "Primary member": "Miembro principal",
    "Client status": "Estado del cliente",
    "Active clients": "Clientes activos",
    "Inactive clients": "Clientes inactivos",
    "All": "Todo",
    "Project status": "Estado del proyecto",
    "Member status": "Condición de miembro",
    "Active members": "Miembros activos",
    "Limited members": "Miembros limitados",
    "Inactive members": "Miembros inactivos",
    "Contract status": "Estado del contrato",
    "Active contracts": "Contratos activos",
    "Pending contracts": "Contratos pendientes",
    "Finished contracts": "Contratos acabados",
    "Contract template": "Plantilla de contrato",
    "Payment recurrence": "Recurrencia de pagos",
    "Yearly": "Anual",
    "Monthly": "Mensual",
    "Trial": "Prueba",
    "Region": "Región",
    "Field": "Campo",
    "All tasks": "Todas las tareas",
    "Todo": "Tarea",
    "Not done": "No hecho",
    "Done": "Hecho",
    "Delayed": "Retrasado",
    "Important": "Importante",
    "Extra work": "Trabajo extra",
    "I Follow": "Sigo",
    "Commented": "Comentado",
    "Tracked time": "Tiempo registrado",
    "Estimated": "Estimado",
    "Recurring task": "Tarea recurrente",
    "Last import": "Última importación",
    "Period": "Periodo",
    "Client search": "Búsqueda de clientes",
    "Voucher": "Vale",
    "Company status": "Estado de la empresa",
    "Deleted": "Eliminado",
    "All status": "Todos los estados",
    "Payment gateway": "Pasarela de pago",
    "All gateways": "Todas las pasarelas",
    "Uku manually": "Uku manualmente",
    "Braintree": "Braintree",
    "Plan status": "Estado del plan",
    "All plans": "Todos los planes",
    "Paid": "Pagado",
    "Paid churn": "Cancelación de pagos",
    "Trial churn": "Turnos de prueba",
    "Plan period": "Período del plan",
    "All periods": "Todos los periodos",
    "Monthly plan": "Plan mensual",
    "Yearly plan": "Plan anual",
    "Company search": "Búsqueda de empresas",
    "User search": "Busqueda Usuario",
    "Name key search": "Búsqueda por clave de nombre",
    "None filter": "Ningún filtro",
    "OK": "OK",
    "Start date cannot be later than due date": "La fecha de inicio no puede ser posterior a la fecha de vencimiento",
    "tasks": "tareas",
    "task(s) had errors": "la(s) tarea(s) tenía(n) errores",
    "tasks selected": "tareas seleccionadas",
    "Postpone": "Aplazar",
    "Mark done": "Marca hecha",
    "Hide multiselect": "Ocultar multiselección",
    "Delete task(s)": "Eliminar tarea(s)",
    "All of the data related to the task will be deleted": "Se borrarán todos los datos relacionados con la tarea",
    "Some tasks include other people. Are you sure you want to delete?": "Algunas tareas incluyen a otras personas. ¿Está seguro de que desea borrar?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Se ha registrado tiempo en algunas de las actividades seleccionadas. ¿Está seguro de que desea borrarlo?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Se ha realizado un seguimiento del tiempo dedicado a algunas de las actividades seleccionadas. Algunas tareas incluyen a otras personas. ¿Está seguro de que desea borrar?",
    "task(s) were not marked done": "la(s) tarea(s) no fue(n) marcada(s) como realizada(s)",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Compruebe si se ha completado la lista de comprobación o se ha introducido el tiempo y se le han asignado",
    "task(s) were not deleted": "la(s) tarea(s) no ha(n) sido eliminada(s)",
    "task(s) time was not updated": "la hora de la(s) tarea(s) no se actualizó",
    "Please make sure that you can add time to task": "Por favor, asegúrese de que puede añadir tiempo a la tarea",
    "invoice table row": "fila de la tabla de facturas",
    "invoice table row(s) had errors": "la(s) fila(s) de la tabla de facturación tenía(n) errores",
    "invoice table row(s) selected": "fila(s) de la tabla de facturas seleccionada(s)",
    "Create": "Crear",
    "Mark paid": "Marca Pagada",
    "Send to client": "Enviar al cliente",
    "Recalculate": "Recalcular",
    "Export to {0}": "Exportar a {0}",
    "Update Status from {0}": "Actualizar estado desde {0}",
    "Void invoice": "Factura nula",
    "Delete invoice": "Borrar factura",
    "Restore invoice": "Restaurar factura",
    "Mark unpaid": "Marcar sin pagar",
    "Invoices": "Facturas",
    "Download to Excel": "Descargar a Excel",
    "Revenue split": "Reparto de ingresos",
    "Tax": "Impuestos",
    "Description": "Descripción",
    "Percent": "Porcentaje",
    "Integration Id": "Id. integración",
    "Integration Code": "Código de Integración",
    "Name on invoice": "Nombre en la factura",
    "Restore": "Restaurar",
    "Archive": "Archivo",
    "Hide": "Ocultar",
    "Are you sure?": "¿Estás seguro?",
    "Invoice seller": "Vendedor de facturas",
    "Company name": "Nombre de la empresa",
    "Address": "Dirección",
    "Company number": "Número de empresa",
    "Tax number": "Número de identificación fiscal",
    "Bank": "Banco",
    "IBAN": "IBAN",
    "Delete logo": "Borrar logotipo",
    "Upload logo file": "Cargar el archivo del logotipo",
    "Max. dimensions 130 x 130 px": "Dimensiones máximas 130 x 130 px",
    "Import finished!": "¡Importación finalizada!",
    "Failed to import {0} records": "Fallo al importar {0} registros",
    "Download report": "Descargar reporte",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Resultado: añadido {0}, actualizado {1}, omitido {2}, no se ha podido importar {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Resultado: añadido {0}, actualizado {1}, omitido {2}",
    "What’s next?": "¿Qué sigue?",
    "To work effectively with your client base, complete the following steps:": "Para trabajar eficazmente con su clientela, siga los pasos siguientes:",
    "Read more ›": "Leer más '",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "A continuación sólo verá los clientes importados activos. Para ver todos los clientes, elimine el filtro \"Última importación\".",
    "View clients": "Ver clientes",
    "Add <b>primary member</b> to every client.": "Añada <b>un miembro primario</b> a cada cliente.",
    "Add <b>task plan</b> to automate recurring tasks.": "Añada <b>un plan de tareas</b> para automatizar las tareas recurrentes.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Configure el resumen mensual automático en la aplicación {0} de Uku para importar el volumen de trabajo.",
    "Title": "Título",
    "Field type": "Tipo de campo",
    "Field name": "Nombre del campo",
    "Client section": "Sección de clientes",
    "Choices": "Elecciones",
    "Type each choice on a separate line": "Escriba cada opción en una línea separada",
    "Required": "Requerido",
    "For all topics": "Para todos los temas",
    "For specific topics": "Para temas específicos",
    "Topics": "Temas",
    "Non-billable": "No facturable",
    "Edit task custom field": "Editar el campo personalizado de la tarea",
    "Add task custom field": "Añadir campo personalizado de tarea",
    "Edit client custom field": "Editar el campo personalizado del cliente",
    "Add client custom field": "Añadir campo personalizado de cliente",
    "Choice {0}": "Elección {0}",
    "Are you sure that you want to delete this custom field?": "¿Está seguro de que desea eliminar este campo personalizado?",
    "Warning!": "¡Advertencia!",
    "This custom field is in use. Do you wish to archive it?": "Este campo personalizado está en uso. ¿Desea archivarlo?",
    "Reconnect": "Reconectarse",
    "Send test email": "Enviar prueba de correo electrónico",
    "Email address or username": "Dirección de correo electrónico o nombre de usuario",
    "Other": "Otro",
    "Set default email server for company": "Establecer el servidor de correo electrónico predeterminado de la empresa",
    "My default email": "Mi correo electrónico por defecto",
    "Depends on": "Depende de",
    "Todo - Blocking": "Todo - Bloqueo",
    "In progress - Blocking": "En curso - Bloqueo",
    "In progress": "En progreso",
    "Client code": "Código Cliente",
    "Primary user": "Usuario principal",
    "Added date": "Fecha de creación",
    "Updated": "Actualizado",
    "Contract count": "Nº de contratos",
    "Integration": "Integración",
    "No data available": "No hay datos disponibles",
    "No results found": "No se han encontrado resultados",
    "Loading": "Cargando",
    "Sort by": "Ordenar por",
    "{0}-{1} of {2}": "{0}-{1} de {2}",
    "Rows per page": "Filas por página",
    "Ongoing": "En curso",
    "important": "importante",
    "Read more": "Leer más",
    "Add to previous time entry": "Añadir a la entrada de tiempo anterior",
    "Add to next time entry": "Añadir a la siguiente entrada de tiempo",
    "Add new task": "Añadir nueva Tarea",
    "Cut previous time entry": "Cortar la entrada de tiempo anterior",
    "Cut next time entry": "Cortar la próxima entrada",
    "Missing time entry": "Falta la entrada de tiempo",
    "Overlapping time entries": "Solapamiento de entradas de tiempo",
    "Member from custom fields": "Miembro de campos personalizados",
    "Delegated to": "Delegado a",
    "Delegated by": "Delegado por",
    "Visible members": "Miembros visibles",
    "Member type": "Tipo de miembro",
    "Groups": "Grupos",
    "Custom field": "Campo personalizado",
    "Contact search": "Búsqueda de contactos",
    "Task start": "Inicio de la tarea",
    "Task due": "Tarea pendiente",
    "Task finish": "Finalización de la tarea",
    "Custom date": "Fecha personalizada",
    "Never": "Nunca",
    "Referral status": "Estado de la remisión",
    "Invited": "Invitado",
    "Registered": "Registrado",
    "Earned": "Ganado",
    "Agreed work is still expected": "Aún se espera el trabajo acordado",
    "Accepted flextime": "Horario flexible aceptado",
    "Declined flextime": "Tiempo flexible rechazado",
    "Cancelled flextime": "Horario flexible cancelado",
    "Updated flextime": "Horario flexible actualizado",
    "Calendar deleted": "Calendario eliminado",
    "Calendar created": "Calendario creado",
    "Calendar approved": "Calendario aprobado",
    "Calendar declined": "Calendario rechazado",
    "Calendar updated": "Calendario actualizado",
    "Flextime balance updated": "Balance actualizado del horario flexible",
    "Flextime": "Horario flexible",
    "Vacation": "Vacaciones",
    "Balance": "Saldo",
    "Comment": "Comentario",
    "History": "Historial",
    "Action": "Acción",
    "Who": "Quién",
    "Take a vacation or mark an absence": "Tomarse unas vacaciones o marcar una ausencia",
    "Away": "Duración",
    "Flextime bonus": "Bonificación por horario flexible",
    "Approver": "Aprobador",
    "Vacation available": "Vacaciones disponibles",
    "Type": "Tipo",
    "Reduce agreed working hours": "Reducir las horas de trabajo acordadas",
    "Reject": "Rechazar",
    "Approve": "Aprobar",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Baja por enfermedad",
    "Parental leave": "Permiso parental",
    "Working hours": "Horario de trabajo",
    "Mon-Fri, 40h weekly, 8h daily": "De lunes a viernes, 40h semanales, 8h diarias",
    "Customize": "Personalizar",
    "Total": "Total",
    "Settings": "Ajustes",
    "Work on holidays": "Trabajar en vacaciones",
    "Get {0} in cash for every referral who becomes a Uku client.": "Obtenga {0} en metálico por cada recomendación que se convierta en cliente de Uku.",
    "Copy your invite link": "Copie el enlace de su invitación",
    "Hide message": "Ocultar mensaje",
    "View message": "Ver mensaje",
    "Your statistics": "Sus estadísticas",
    "Copy message": "Copiar mensaje",
    "How it works": "Cómo funciona",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Invite a sus amigos a Uku y les regalaremos un mes de Uku y les mostraremos cómo impulsar su negocio.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "Una vez que su referido se convierta en un cliente pagador de Uku, le enviaremos una tarjeta de regalo {0}.",
    "More ways to earn cash": "Más formas de ganar dinero",
    "referral_email_content": "Hola, {{friend_name}}!<br><br>He estado usando el software de gestión de tareas y CRM moderno de Uku y creo que a ti también te gustará. Estas son algunas de las funciones que uso habitualmente:<br>* Automatización de tareas: funciona como un asistente personal<br>* Seguimiento del tiempo: más simple y preciso que Toggl<br>* Gestión de clientes: toda la información esencial en un solo lugar<br>* Facturación: automática y rápida<br>* Monitoreo de acuerdos con clientes: mantiene todos los acuerdos bajo control<br><br>Con mi recomendación, obtendrás una prueba gratuita de 30 días y capacitación gratuita para el equipo. Puedes obtener más información aquí: {{learn_more_link}}<br><br>{{accept_invite_link}} (¡Acepta la invitación y pruébalo!)<br><br>Saludos cordiales,<br>{{your_name}}",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Escriba su opinión sobre Uku y reciba <a href='/api/help_link/referral_feedback' target='_blank'>una tarjeta regalo de{0} aquí</a>",
    "Expand": "Expandir",
    "Wait until event status": "Esperar hasta que el estado del evento",
    "Wait until project status": "Esperar hasta que el estado del proyecto",
    "Week(s)": "Semana(s)",
    "Day(s)": "Día(s)",
    "Rule": "Regla",
    "Depends on event": "Depende del acontecimiento",
    "Depends on project": "Depende del proyecto",
    "Due date in": "Fecha de vencimiento en",
    "Status": "Estado",
    "Select event": "Seleccionar evento",
    "Select project": "Selecciona un proyecto",
    "Find event...": "Buscar evento...",
    "Find project...": "Buscar proyecto...",
    "Custom recurrence": "Recurrencia personalizada",
    "Every": "Cada",
    "In case of holiday": "En caso de vacaciones",
    "Set time": "Hora fijada",
    "Start time": "Hora de inicio",
    "Repeat from": "Repita desde",
    "Previous repeat from: {0}": "Repetición anterior desde: {0}",
    "On date": "A fecha",
    "Plus days": "Más días",
    "Due date time": "Fecha de vencimiento Hora",
    "Remove recurrence": "Eliminar la recurrencia",
    "Repeat": "Repetir",
    "month": "mes",
    "quarter": "trimestre",
    "year": "año",
    "1st month": "1er mes",
    "2nd month": "2º mes",
    "3rd month": "3er mes",
    "Day {0}": "Día {0}",
    "Show before": "Mostrar antes",
    "Keep the day": "Mantenga el día",
    "Show after": "Mostrar después",
    "From start date": "Desde la fecha de inicio",
    "From beginning of the month": "Desde principios de mes",
    "All days (Mon to Sun)": "Todos los días (de lunes a domingo)",
    "Mon to Fri (incl. holidays)": "De lunes a viernes (festivos incluidos)",
    "Mon to Fri (excl. holidays)": "De lunes a viernes (excepto festivos)",
    "1st": "1er",
    "2nd": "2do",
    "3rd": "3°",
    "Does not repeat": "No repite",
    "Daily": "Diariamente",
    "Weekly on {0}": "Semanal en {0}",
    "Monthly on day {0}": "Mensualmente en el día {0}",
    "Quarterly on {0} month {1} day": "Trimestralmente el {0} mes {1} día",
    "Yearly on {0} {1}": "Anualmente en {0} {1}",
    "Custom...": "Personalizado...",
    "Incorrect time": "Hora incorrecta",
    "Add repeat": "Añadir repetición",
    "Email added to queue": "Correo electrónico añadido a la cola",
    "Communication timeline": "Calendario de comunicación",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Active Email App en App Store para enviar correos electrónicos automatizados y ver sus comunicaciones pasadas y futuras en un solo lugar.",
    "Go to App Store": "Ir a App Store",
    "Unknown": "Desconocido",
    "<b>Email</b> from": "<b>Correo electrónico</b> de",
    "To": "Hasta",
    "Planned": "Planificado",
    "Automated emails scheduled to be sent in the future": "Correos electrónicos automatizados programados para ser enviados en el futuro",
    "Send e-mail": "Enviar E-mail",
    "Template unlinked": "Plantilla desvinculada",
    "Icon": "Icono",
    "Link name": "Nombre del enlace",
    "Link URL": "Enlace URL",
    "Open in new tab": "Abrir en nueva pestaña",
    "Visible": "Visible",
    "External": "Externo",
    "Not external": "No externo",
    "Company default": "Morosidad de la empresa",
    "Not visible": "No visible",
    "Use company default": "Utilizar el valor por defecto de la empresa",
    "or choose icon": "o elija el icono",
    "Find member...": "Encuentre miembros...",
    "I'll take it": "Me lo llevo",
    "Remove me": "Removerme",
    "Remove from task": "Eliminar de la tarea",
    "Learn more": "Saber más",
    "Company settings edit is disabled by owner": "La edición de la configuración de la empresa está desactivada por el propietario",
    "<b>Exported</b> {0} to {1}": "<b>Exportado</b> {0} a {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Enviado al cliente</b> {0} desde {1}",
    "<b>Paid {0}</b> {1}": "<b>Pagado {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Anulado</b> {0}",
    "Do you wish to mark the task done for everyone?": "¿Desea marcar la tarea realizada para todos?",
    "No, remove me": "No, retíreme",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "La tarea no se marcará como realizada, pero el usuario se elimina de los asignados y se añade a los seguidores de la tarea",
    "Invalid email": "Email no válido",
    "Accounting": "Contabilidad",
    "General": "General",
    "Advertising / Marketing/ PR": "Publicidad / Marketing/ RR",
    "Architecture": "Arquitectura",
    "Construction": "Construcción",
    "Consulting - IT, software": "Consultoría - TI, software",
    "Consulting - Management": "Consultoría - Gestión",
    "Finance": "Finanzas",
    "Legal": "Legal",
    "Medicine / Pharmacy ": "Medicina / Farmacia",
    "Non-profit": "Sin Ánimo de Lucro",
    "Web design": "Diseño web",
    "Web development": "Desarrollo Web",
    "Max 140 characters": "Máximo 140 caracteres",
    "Please complete the checklist": "Por favor, complete la lista de comprobación",
    "It is required to mark all checklist items as done": "Es necesario marcar todos los elementos de la lista de comprobación como realizados",
    "Please enter time spent": "Por favor, introduzca el tiempo empleado",
    "Inserting time is essential for this client": "Insertar el tiempo es esencial para este cliente",
    "Only me": "Solo yo",
    "Private": "Privado",
    "Edit note": "Editar nota",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Añada información adicional sobre el cliente, como acuerdos especiales, contraseñas, etc.",
    "Edit": "Editar",
    "Workdays": "Días laborables",
    "Workhours": "Horas de trabajo",
    "Weeks": "Semanas",
    "Clear filters": "Limpiar filtros",
    "Save filters": "Guardar filtros",
    "Expected": "Esperados",
    "Estimation": "Estimación",
    "Do you also want to postpone the due date?": "¿También quiere posponer la fecha de vencimiento?",
    "{0} week": "{0} semana",
    "{0} weeks": "{0} semanas",
    "Vacations": "Vacaciones",
    "Holidays": "Vacaciones",
    "Tax dates": "Fechas fiscales",
    "Accounting news": "Noticias de contabilidad",
    "Company events": "Eventos de empresa",
    "Member birthdays": "Cumpleaños de los miembros",
    "Contact birthdays": "Contacto cumpleaños",
    "Group items": "Agrupar elementos",
    "Don't group": "No agrupar",
    "{0} away": "{0} lejos",
    "Member birthday | Member birthdays": "Cumpleaños de los socios | Cumpleaños de los socios",
    "Contact birthday | Contact birthdays": "Contacto cumpleaños | Contacto cumpleaños",
    "Contact birthday": "Contacto",
    "Member birthday": "Cumpleaños del miembro",
    "Are you sure you wish to delete this link?": "¿Está seguro de que desea eliminar este enlace?",
    "Reference name": "Nombre de referencia",
    "Reference link": "Enlace de referencia",
    "Free trial": "Prueba gratuita",
    "Solo": "Solo",
    "Team": "Equipo",
    "Enterprise": "Empresa",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Plugin del navegador Chrome para Uku para gestionar sus tareas, clientes y realizar un seguimiento del tiempo.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Configure planes de tareas/trabajos para automatizar su flujo de trabajo, añada temas, campos personalizados y modifique sus preferencias.",
    "Setup client groups, custom fields and modify your preferences.": "Configure grupos de clientes, campos personalizados y modifique sus preferencias.",
    "test": "prueba",
    "Anti Money Laundering": "Lucha contra el blanqueo de capitales",
    "Setup your customer AML and get instant reminders when auditing is due.": "Configure el AML de sus clientes y reciba recordatorios instantáneos cuando deba realizar la auditoría.",
    "flextime_description": "Manage work-life balance with ease.",
    "Smart Accounts": "Cuentas inteligentes",
    "Automatically imports work statistics from your accounting software.": "Importa automáticamente las estadísticas de trabajo de su programa de contabilidad.",
    "Merit Aktiva": "Mérito Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Acelere el proceso de facturación a sus clientes con listas de precios y contratos inteligentes.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "El informe visual le dirá exactamente lo rentable o no que es su cliente.",
    "Emailing description": "Send emails directly from Uku and automate recurring emails",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Sincronice los datos de los clientes de Uku a e-conomic y viceversa. Ver la información del libro de ventas de cada cliente.",
    "Xero": "Xero",
    "xero_description": "Import clients from Xero to Uku and automate your billing.",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Import clients from QuickBooks Online to Uku and automate your billing.",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Scoro",
    "Export sales invoices.": "Exporte facturas de venta.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Import clients from Fortnox to Uku and automate your billing.",
    "Magic button": "Botón mágico",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Con un solo clic: una forma rápida y sencilla de crear tareas importantes. Por ejemplo, una llamada telefónica de un cliente.",
    "With suppliers, you make your projects and partners management more efficient.": "Con los proveedores, la gestión de sus proyectos y socios será más eficaz.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Una gestión de proyectos potente y flexible sirve para diversos casos de uso y flujos de trabajo.",
    "client_portal_app_description": "Client portal simplifies collaboration with clients. Securely receive documents, assign tasks, and share information.",
    "Chat": "Chat",
    "chat_app_description": "Enhance team collaboration, client communication, and overall efficiency with the Chat.",
    "Companies House": "Registro Mercantil",
    "companies_house_app_description": "Set up Companies House data for UK clients and get reminders when statements are due.",
    "documents_app_description": "documents_app_description",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "Importa los datos de tus clientes desde Freeagent a Uku.",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Conéctese y descubra herramientas que le ayudarán a gestionar su negocio.",
    "Subscribe now": "Suscríbete ahora",
    "Compare plans": "Comparar planes",
    "Add company": "Agregar empresa",
    "BETA": "BETA",
    "Setup": "Configuración",
    "Power up": "Encendido",
    "Integrations": "Integraciones",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hola! ¿Desea trabajar con un equipo y utilizar funciones adicionales? No hay problema, ¡añada primero su empresa!",
    "Read more about Uku plans": "Más información sobre los planes de Uku",
    "Contact role": "Función de contacto",
    "Contact roles": "Funciones de contacto",
    "Client groups": "Grupos de clientes",
    "Client fields": "Campos del cliente",
    "Contact fields": "Campos de contacto",
    "View archive": "Ver archivo",
    "Restore from archive": "Restaurar desde archivo",
    "Empty list": "Lista vacía",
    "Task fields": "Campos de tareas",
    "task topics": "temas de tareas",
    "Keep the task opened when starting the timer": "Mantenga la tarea abierta al iniciar el temporizador",
    "task templates": "plantillas de tareas",
    "Author": "Autor",
    "Duplicate": "Duplicar",
    "Uku task templates": "Plantillas de tareas Uku",
    "Are you sure that you want to delete this task template?": "¿Está seguro de que desea eliminar esta plantilla de tareas?",
    "Templates": "Plantillas",
    "Overview": "Resumen",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Color",
    "Are you sure to delete this field? You may lose the data.": "¿Está seguro de eliminar este campo? Podría perder los datos.",
    "Add field": "Agregue campo",
    "Add section": "Añadir sección",
    "multiline": "multilínea",
    "Import": "Importar",
    "Import data": "Importar datos",
    "Automate data collection with Smart Accounts": "Automatice la recogida de datos con Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Importe entradas de compras y ventas, entradas totales y recuento de líneas de entrada;</li><li>Automatice la recogida de datos con Smart Accounts;</li><li>Facturación más rápida y precisa gracias al intercambio automatizado de datos. Uku reúne la información para preparar las facturas de los clientes en un solo lugar y hace que la facturación sea eficiente.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automate your billing process by connecting Xero to Uku.</p> <div class='body-2'><p>Benefits of the Xero integration:</p><ul><li>Import all your clients from Xero to Uku with just a couple of clicks</li><li>Import product codes and classificators to Uku</li><li>Create invoices automatically in Uku and send them to Xero</li></ul></div>",
    "Import clients from {0}": "Importar clientes de {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Antes de importar clientes, debe autorizarse con Xero y seleccionar la Empresa.",
    "Authorize Xero to start import": "Autorizar a Xero para iniciar la importación",
    "Failed to import clients": "Fallo al importar clientes",
    "Failed to connect to WS": "Fallo al conectar con WS",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "Firmas de correo electrónico",
    "Everyone": "Todos",
    "Access": "Acceso",
    "Creator": "Creador",
    "Are you sure you want to delete this signature? Some emails will be affected": "¿Está seguro de que desea eliminar esta firma? Algunos correos electrónicos se verán afectados",
    "Email addresses": "Direcciones de email",
    "Signatures": "Firmas",
    "Send emails": "Enviar emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku se integra de forma segura con su correo electrónico para ayudarle a gestionar y automatizar la comunicación",
    "Use {0} address": "Utilice la dirección {0}",
    "connect your email address": "conecte su dirección de correo electrónico",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Conectar con Microsoft Exchange u otro servidor de correo electrónico(SMTP)",
    "Email integration reconnected": "Integración del correo electrónico reconectada",
    "Are you sure you want to delete this email integration?": "¿Está seguro de que desea eliminar esta integración de correo electrónico?",
    "Email templates": "Plantillas de correo electrónico",
    "Add email template": "Añadir plantilla de correo electrónico",
    "Are you sure you want to save this template? Some tasks will be affected": "¿Está seguro de que desea guardar esta plantilla? Algunas tareas se verán afectadas",
    "Clients can leave task messages by replying to client portal email": "Los clientes pueden dejar mensajes de tareas respondiendo al correo electrónico del portal del cliente",
    "Send a copy of client's response to member's inbox": "Enviar una copia de la respuesta del cliente a la bandeja de entrada del miembro",
    "Email recipients can leave task comments by replying to a task email": "Los destinatarios del correo electrónico pueden dejar comentarios sobre la tarea respondiendo a un correo electrónico de tarea",
    "economic_app_overview_text": "<p class='title'>Automate your billing process by connecting e-conomic to Uku</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku with just a couple of clicks</li><li>import products and classificators from e-conomic to Uku</li><li>create invoices automatically in Uku and send them to e-conomic</li></ul></p></div>",
    "Default layout": "Diseño predeterminado",
    "Change agreement ID": "Cambiar el ID del acuerdo",
    "Failed to connect to server": "Error al conectar con el servidor",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes, la información de los clientes y los clasificadores. En el último paso podrá seleccionar qué clientes desea añadir o actualizar.",
    "Connect e-conomic": "Conectar e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Antes de importar clientes, debe conectar Uku y el software económico. Para ello, cree un acuerdo económico e introduzca aquí el ID del acuerdo.",
    "Step {0}": "Paso {0}",
    "Get agreement ID": "Obtener la identificación del acuerdo",
    "Insert agreement ID": "Insertar ID del acuerdo",
    "Connect": "Conectar",
    "quickbooks_app_overview_text": "<p class='title'>Automate your billing process by connecting QuickBooks Online to Uku.</p> <div class='body-2'><p>Benefits of the QuickBooks integration:</p><ul><li>Import all your clients from QuickBooks to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes, información de clientes y clasificadores desde QuickBooks. En el último paso podrá seleccionar qué clientes desea añadir o actualizar.",
    "Before importing clients, you need to connect with QuickBooks.": "Antes de importar clientes, debe conectarse con QuickBooks.",
    "Connected to QuickBooks": "Conectado a QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automate your billing process by connecting Fortnox to Uku.</p> <div class='body-2'><p>Benefits of the Fortnox integration:</p><ul><li>Import all your clients from Fortnox to Uku with just a couple of clicks.</li><li>Import products and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes, información de clientes y clasificadores de Fortnox. En el último paso podrá seleccionar qué clientes desea añadir o actualizar.",
    "Before importing clients, you need to connect with Fortnox.": "Antes de importar clientes, debe conectarse con Fortnox.",
    "Connect to Fortnox": "Conectar con Fortnox",
    "Connected to Fortnox": "Conectado a Fortnox",
    "Delete template": "Eliminar plantilla",
    "Public": "Público",
    "Workflow templates": "Plantillas de flujo de trabajo",
    "No workflow templates yet": "Aún no hay plantillas de flujo de trabajo",
    "Modified": "Modificado",
    "Uku workflow templates": "Plantillas de flujo de trabajo Uku",
    "Are you sure you wish to delete this workflow?": "¿Está seguro de que desea eliminar este flujo de trabajo?",
    "Project fields": "Campos del proyecto",
    "Progress step": "Paso a paso",
    "Rename project": "Cambiar el nombre del proyecto",
    "Project statuses": "Estados del proyecto",
    "You can use the statuses to restrict the workflow.": "Puede utilizar los estados para restringir el flujo de trabajo.",
    "Project phases": "Fases del proyecto",
    "Make your progress beautiful.": "Haga que su progreso sea hermoso.",
    "Permissions": "Permisos",
    "Users can manage workflow templates": "Los usuarios pueden gestionar plantillas de flujo de trabajo",
    "project_app_overview_text": "Handle projects from initiation to completion with ease.",
    "project_app_overview_description": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Configurar la tarea de resumen",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku generará la tarea con el siguiente título y tema el último día del mes.",
    "Task title": "Título de la tarea",
    "Recurrence": "Recurrente",
    "First import start date": "Fecha de inicio de la primera importación",
    "Count changes from previous periods": "Cambios en el recuento respecto a periodos anteriores",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Si está activada, los cambios realizados en periodos anteriores se añadirán al mes actual. Si se desactiva, los cambios realizados en periodos anteriores no se contabilizarán.",
    "Automatically finish summary tasks": "Finalizar automáticamente las tareas de resumen",
    "If enabled, summary tasks will be created as finished.": "Si está habilitado, las tareas de resumen se crearán como finalizadas.",
    "Configure data fields": "Configurar los campos de datos",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Seleccione el campo Uku correspondiente para cada campo importado. Se resumirán los mismos campos. Dejando algún campo en blanco será ignorado.",
    "New custom field": "Nuevo campo personalizado",
    "Show more": "Mostrar más",
    "Every month": "Cada mes",
    "Last work day of the month": "Último día laborable del mes",
    "Last day of the month": "Último día del mes",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Día {0} del próximo mes",
    "Settings saved": "Ajustes guardados",
    "Uku will let you know when it is ready.": "Uku le avisará cuando esté listo.",
    "Reload data": "Recargar datos",
    "months": "meses",
    "This will overwrite existing summary tasks new values.": "Esto sobrescribirá los nuevos valores de las tareas de resumen existentes.",
    "Overwrite": "Sobreescribir",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes y su información desde Trigon. En el paso final, puedes seleccionar qué clientes quieres agregar o actualizar.",
    "Connect Trigon": "Conectar Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Antes de importar clientes, es necesario conectar el software Uku y Trigon. Para ello, introduzca sus credenciales aquí.",
    "Insert email and password": "Insertar correo electrónico y contraseña",
    "Automate your anti money laundering process": "Automatice su proceso de lucha contra el blanqueo de capitales",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Está a punto de activar el proceso contra el blanqueo de capitales. Durante el mismo se añadirán nuevos campos adicionales a los datos de sus clientes y también el sistema empezará a recordarle su actualización.<br><br>Los campos adicionales son:<ul><li>Perfil de riesgo</il><li>Perfil válido hasta</il><li>Estaus AML</il><li>Documento NO</il><li>Documento válido hasta</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Está a punto de activar el proceso antiblanqueo de capitales. Durante el mismo se añadirán nuevos campos adicionales a los datos de sus clientes y también el sistema empezará a recordarle su actualización.<br><br>Los campos adicionales son:<ul><li>Perfil de riesgo</il><li>Próxima comprobación AML</il><li>Pasa/Falla</il><li>Tipo de identificación</il><li>Número de identificación</il><li>Fecha de caducidad</il><li>Comprobaciones adicionales</li></ul>",
    "Do not change client custom fields created by Uku": "No modifique los campos personalizados del cliente creados por Uku",
    "day(s) before": "día(s) antes",
    "Task name": "Nombre de la tarea",
    "Assigned": "Asignado",
    "Note": "Nota",
    "Manual run": "Ejecución manual",
    "Create a task when the document expires": "Crear una tarea cuando el documento caduque",
    "Create a task when the risk profile must be updated": "Crear una tarea cuando deba actualizarse el perfil de riesgo",
    "Flextime period": "Periodo de horario flexible",
    "Confirmation period": "Período de confirmación",
    "Weekly": "Semanal",
    "Add agreement": "Añadir acuerdo",
    "flextime_app_overview_text": "<p class='title'>Get an overview of your team's working hours, overtime, and vacation balance.</p> <div class='body-2'><p></p><p>Flextime benefits:</p><ul><li>Convenient overview of work and overtime</li><li>Accessible vacation management and balance overview</li><li>Easy data export for your accountant</li></ul></div>",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "Manage your partners and vendors.",
    "Supplier type": "Tipo de proveedor",
    "Parent type": "Tipo de padre",
    "Edit supplier type": "Editar tipo de proveedor",
    "New supplier type": "Nuevo tipo de proveedor",
    "Are you sure you wish to delete this supplier type?": "¿Está seguro de que desea eliminar este tipo de proveedor?",
    "Types": "Tipos",
    "Supplier types": "Tipos de proveedores",
    "No supplier types yet": "Aún no hay tipos de proveedores",
    "tripletex_app_overview_text": "<p class='title'>Automate your billing process by connecting Tripletex to Uku.</p> <div class='body-2'><p>Benefits of the Tripletex integration:</p><ul><li>Import all your clients from Tripletex to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes, información de clientes y clasificadores de Tripletex. En el último paso podrá seleccionar qué clientes desea añadir o actualizar.",
    "Connect Tripletex": "Conectar Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Antes de importar clientes, necesita conectar Uku y el software Tripletex. Para ello, cree un token de empleado e introdúzcalo aquí.",
    "Get employee token": "Obtener token de empleado",
    "Insert employee token": "Insertar ficha de empleado",
    "Install": "Instalar",
    "Open Chrome browser to install": "Abra el navegador Chrome para instalar",
    "Works with your online accounting software.": "Funciona con su software de contabilidad en línea.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Las nuevas tareas pueden caer como un rayo y por eso Mini Uku es su mejor amigo. No importa si está haciendo transferencias bancarias o trabajando en su programa de contabilidad; con Mini Uku puede añadir nuevas tareas, controlar el tiempo y estar al tanto de todas sus notificaciones desde cualquier sitio web.<br><br>Con un solo clic en el icono del búho obtendrá una visión general de toda su jornada laboral y le ayudará a planificar su horario de forma más eficiente.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "<p class='title'>Import clients and the volume of work to get one report with work done data for all your clients.</p><div class='body-2'><p>Make your data collection fast and accurate with Merit Aktiva and Uku integration. Uku automatically imports sales and purchase invoices, documents, entries, etc. for each client and performs volume of work and time-entries in one interactive report. No more switching between clients in your accounting software to get information about documents processed to create invoices or monitor client performance. Compared to Merit, Uku imports the actual amount of entries for last month, taking into account all changes that were inserted into previous periods. Meaning that you don't have to remember or write down any changes you have made - Uku has all that information and so will you. Automated data collection saves you time and eliminates human errors.</p><p>Uku and Merit Aktiva integration helps you to:</p><p><ul><li>Quickly and accurately gather data - volume of work is imported to Uku from Merit automatically</li><li>Analyse workload and time by having a full overview of work done and time spent on clients</li><li>Automate the creation of monthly summaries </li><li>Get an overview of the actual workload each month</li></ul></p><p>With Uku - Merit integration you can import the amount of:</p><p><ul><li>Documents</li><li>Entries</li><li>Sales invoices</li><li>Purchase invoices</li><li>Bank entries</li><li>Cash entries</li><li>VAT entries</li><li>Stock entries</li><li>Etc.</li></ul></p></div>",
    "Import clients": "Importar clientes",
    "documents_app_overview_text": "<div class='body-2'><p>Guarda todos tus archivos directamente en el repositorio de documentos de tu empresa. Mantén una copia de seguridad en Uku.</p><p>Características principales:</p><ul><li><b>Estructura de carpetas:</b> Define la carpeta principal donde Uku debe guardar los archivos. Puedes definir carpetas específicas por cliente o hacer que Uku genere las carpetas por cliente/por año/por mes para ti.</li><li><b>Qué archivos guardar:</b> Haz que Uku guarde todos los archivos cargados o creados en Uku en tu repositorio de documentos o solo los cargados por los clientes. Tienes control total sobre lo que se almacena en el repositorio y lo que no.</li><li><b>Abrir archivos para revisión:</b> Los archivos cargados se abren directamente en tu repositorio de documentos. No es necesario descargar el archivo para trabajar con él.</li><li><b> Copia de seguridad:</b> ¡Si lo desea, puede realizar una copia de seguridad de todos sus archivos en Uku!</li></li></ul><p></p><p>Sistemas de administración de archivos compatibles:</p><div class='d-flex align-center'><img style='width: 45px;' src='/static/img/google-drive.svg'> <b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>Google Drive</b><img style='width: 55px;' src='/static/img/onedrive.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>OneDrive</b><img style='width: 50px;' src='/static/img/sharepoint.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>SharePoint</b></div><p style='padding-bottom: 30px'></p></div>",
    "Connect your existing document management system": "Conecte su sistema de gestión documental existente",
    "Main folder": "Carpeta principal",
    "Under this folder, Uku automatically creates folders for each client.": "Bajo esta carpeta, Uku crea automáticamente carpetas para cada cliente.",
    "You can customize each client folder separately under client settings.": "Puede personalizar cada carpeta de cliente por separado en ajustes de cliente.",
    "Automatically create Public folder for client files and Private folder for member files": "Cree automáticamente una carpeta pública para los archivos de los clientes y una carpeta privada para los archivos de los miembros",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Cree automáticamente una subcarpeta Año / Mes bajo cada cliente para clasificar los archivos",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Cree automáticamente subcarpetas de Notas y Plantillas en cada cliente para clasificar los archivos",
    "Add task files added by Members": "Añadir archivos de tareas añadidos por los diputados",
    "Add task files added by Clients (from emails and client portal)": "Añadir archivos de tareas añadidos por los clientes (desde correos electrónicos y el portal de clientes)",
    "Backup files to Uku file storage": "Copia de seguridad de archivos en el almacenamiento de archivos Uku",
    "Perfect example": "Un ejemplo perfecto",
    "Setup your SharePoint connection": "Configure su conexión SharePoint",
    "Site URL": "URL del sitio",
    "Client ID": "ID de cliente",
    "Client secret": "Cliente secreto",
    "Connection successful!": "¡Conexión exitosa!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "Al desconectar el servicio Uku ya no podrá acceder a los documentos.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Seleccionar carpeta",
    "Manage": "Gestionar",
    "Refresh": "Refrescar",
    "Be aware of the issues before they become problems": "Sea consciente de los problemas antes de que se conviertan en problemas",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Comparación en tiempo real del contrato con el cliente y el trabajo real realizado;</li><li>Ser consciente de los problemas antes de que se conviertan en problemas;</li><li>Incluso con precios fijos necesita tener mediciones internas. Controle la validez del acuerdo con el cliente comparándolo con la cantidad real de trabajo realizado.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Identidad",
    "Subdomain": "Subdominio",
    "Default language": "Idioma predeterminado",
    "Client portal URL in other languages": "URL del portal del cliente en otros idiomas",
    "Copy URL": "Copiar URL",
    "Trademark": "Marca comercial",
    "Default signature": "Firma por defecto",
    "Trademark text color": "Color del texto de la marca",
    "Choose color": "Selecciona el color",
    "Brand background color": "Color de fondo de la marca",
    "Logo": "Logo",
    "Max. dimensions 180 x 60 px": "Dimensiones máximas 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Borrar ícono",
    "Upload icon file": "Cargar archivo de iconos",
    "Recommended size 260 x 260 px": "Tamaño recomendado 260 x 260 px",
    "Company description": "Descripción de la empresa",
    "Displayed on the login page.": "Se muestra en la página de inicio de sesión.",
    "Describe here what services you offer and how you help your clients.": "Describa aquí qué servicios ofrece y cómo ayuda a sus clientes.",
    "Welcome video": "Vídeo de bienvenida",
    "Displayed on the login page when your client contact enters for the first time": "Se muestra en la página de inicio de sesión cuando su contacto cliente entra por primera vez",
    "Use Uku video": "Utilice Uku video",
    "View": "Ver",
    "Use other video": "Utilizar otro vídeo",
    "Youtube or Vimeo video URL": "URL del vídeo en Youtube o Vimeo",
    "Show file upload box for client tasks": "Mostrar el cuadro de carga de archivos para las tareas del cliente",
    "Invalid data": "Datos inválidos",
    "Client portal preview": "Vista previa del portal del cliente",
    "Client portal URL for {0} copied to clipboard": "URL del portal del cliente para {0} copiada en el portapapeles",
    "Personalize your client portal's menu": "Personalice el menú de su portal de clientes",
    "Menu links saved": "Enlaces de menú guardados",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Añada enlaces personalizados a elementos esenciales como: Documentos, Informes financieros, Formularios de incorporación, Encuestas de opinión, Acuerdos de servicio, Precios, Instrucciones, Facturas. Esta sección le permite construir la estructura del menú, establecer el orden de los elementos y definir los enlaces predeterminados. También puede personalizar los nombres y los enlaces para cada cliente individualmente. Sólo los menús con enlaces definidos se muestran en el portal del cliente. <a href='/api/help_link/cp_menu_links' target='_blank'>Leer más '</a>",
    "Menu links": "Enlaces de menú",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku importará todos los clientes desde FreeAgent. En el último paso podrá seleccionar qué clientes desea añadir o actualizar.",
    "Before importing clients, you need to connect with FreeAgent.": "Antes de importar clientes, debe conectarse con FreeAgent.",
    "Connect to FreeAgent": "Conectarse a FreeAgent",
    "Connected to FreeAgent": "Conectado a FreeAgent",
    "freeagent_app_overview_text": "<p class=‘title’>¡Automatiza la configuración de tu empresa importando clientes desde Freeagent!</p><div class=‘body-2’><p>Importa todos tus clientes desde Freeagent a Uku con solo un par de clics.</p></div>",
    "Add recurring task": "Añadir tarea recurrente",
    "Reminder tasks updated": "Tareas de recordatorio actualizadas",
    "Create recurring tasks for Companies House clients.": "Cree tareas recurrentes para los clientes del Registro Mercantil.",
    "companies_house_app_overview_text": "<p class='title'>Never forget to file your clients' annual statements with Companies House.</p> <div class='body-2'><p>Activating Companies House in Uku will:</p><p><ul><li>Set up Companies House client fields for your clients based in the United Kingdom.</li><li>Automatically keep Companies House data up-to-date for these clients.</li></ul></p><p>Set up reminders to file your clients' statements and tax returns:</p><p><ul><li>Set up yearly recurring tasks for different annual statements.</li><li>Reminder tasks will be created separately for every client based on that client's due dates.</li><li>Customise when these tasks should appear and what should be done.</li></ul></p></div>",
    "buttons": "botones",
    "Show to me": "Muéstreme",
    "magic_button_app_overview_text": "<p class='title'>With one click, add a new task and start the timer.</p> <div class='body-2'><p>Magic buttons allow you to insert urgent work (phone call, email) conveniently.</p><p>Insert all tasks immediately to Uku</p><p>Magic buttons allow you to add urgent tasks (phone call, email) to Uku conveniently. That ensures tasks are inserted into Uku properly.</p><p>Magic buttons:</p><ul><li>Insert a new task and start the timer with one click (move to + button in the header).</li><li>Customise magic buttons according to your needs.</li><li>Modify the client or other information afterward.</li><li>Continue with the previous task that you can quickly access from the magic buttons list.</li></ul></div>",
    "Buttons": "Botones",
    "Member rights": "Derechos de los miembros",
    "Allow managers to view and create their client contracts and invoices": "Permitir a los gestores ver y crear los contratos y facturas de sus clientes",
    "Allow members to view and create their client invoices": "Permitir a los miembros ver y crear las facturas de sus clientes",
    "Allow members to view their client invoices": "Permitir a los miembros ver las facturas de sus clientes",
    "Allow only owners to add and update products": "Permitir sólo a los propietarios añadir y actualizar productos",
    "Allow members to send invoices to clients": "Permitir a los miembros enviar facturas a los clientes",
    "Allow members to confirm their client invoice rows": "Permitir a los miembros confirmar sus filas de facturas de clientes",
    "Send PDF invoice": "Enviar factura PDF",
    "Send invoice copy": "Enviar copia de factura",
    "Default rounding": "Redondeo por defecto",
    "Round all times up to x": "Redondee todos los tiempos a x",
    "Time rounding increment": "Incremento de redondeo de tiempo",
    "Apply time rounding to": "Aplique el redondeo temporal a",
    "Default configuration": "Configuración por defecto",
    "Invoice date": "Fecha de la factura",
    "Invoice entry date": "Fecha de entrada de la factura",
    "Bill tracked time by": "Bill realizó un seguimiento del tiempo mediante",
    "Bill task field by": "Facture el campo de tareas por",
    "Create one invoice merging invoices from the same period": "Crear una sola factura fusionando facturas del mismo periodo",
    "Invoices from the same period": "Facturas del mismo periodo",
    "Hide zero sum lines": "Ocultar las líneas de suma cero",
    "By default, time entry is billable": "Por defecto, la entrada de tiempo es facturable",
    "Invoice number": "Número de factura",
    "Prefix": "Prefijo",
    "Suffix": "Sufijo",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Ajustes de facturación guardados",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimising human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Productos",
    "Contract templates": "Modelos de contrato",
    "Invoice templates": "Plantillas de facturas",
    "Tools": "Herramientas",
    "Replace tax": "Sustituir el impuesto",
    "Old tax": "Impuesto antiguo",
    "New tax": "Nuevo impuesto",
    "Find tax": "Buscar impuestos",
    "Replace VAT in products": "Sustituir el IVA en los productos",
    "Replace VAT in master contracts": "Sustituir el IVA en los contratos marco",
    "Replace VAT in client contracts & draft invoices": "Sustituir el IVA en los contratos con los clientes y en los borradores de facturas",
    "Replace VAT values": "Sustituir los valores del IVA",
    "This action cannot be undone": "Esta acción es irreversible",
    "Replace": "Reemplazar",
    "Result": "Resultado",
    "PDF templates": "Plantillas PDF",
    "E-mail templates": "Plantilla de Correo Electrónico",
    "Edit PDF template": "Editar plantilla PDF",
    "Import classificators": "Importar clasificadores",
    "products": "productos",
    "product": "producto",
    "Product / service": "Producto / servicio",
    "Calculate": "Calcular",
    "Article": "Artículo",
    "Resource": "Recurso",
    "Cost center": "Centro de costes",
    "Taxes": "Impuestos",
    "Code": "Código",
    "Source": "Fuente",
    "Articles": "Artículos",
    "Resources": "Recursos",
    "Cost centers": "Centros de costes",
    "Units": "Unidades",
    "Unit": "Unidad",
    "Bank accounts": "Cuentas bancarias",
    "Bank account": "Cuenta Bancaria",
    "Bank name": "Nombre del banco",
    "SWIFT code": "Código SWIFT",
    "VAT number": "Número de IVA",
    "Do you wish to import only new data or also overwrite existing?": "¿Desea importar sólo datos nuevos o también sobrescribir los existentes?",
    "Only new": "Sólo nuevos",
    "New items will be added. Existing ones will remain unchanged by import.": "Se añadirán nuevos artículos. Los existentes permanecerán inalterados con la importación.",
    "Import everything": "Importar todo",
    "Connect accounting service": "Conectar el servicio de contabilidad",
    "Service": "Servicio",
    "API ID": "API ID",
    "API key": "Clave API",
    "Company Account Id": "Id. de cuenta de la empresa",
    "Api secret": "Api secreta",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Prueba",
    "Lock time entries": "Bloquear entradas de tiempo",
    "Owner rights": "Derechos del propietario",
    "Disable company settings edit for all members": "Desactivar la edición de la configuración de la empresa para todos los miembros",
    "Disable personal clients for members": "Desactivar los clientes personales para los miembros",
    "Show member birthdays": "Mostrar los cumpleaños de los miembros",
    "Show contact birthdays": "Mostrar los cumpleaños de los contactos",
    "Weekly @ Sun {0}": "Semanal @ Sol {0}",
    "Monthly @ last day of month": "Mensualmente @ último día del mes",
    "Company event list": "Lista de eventos de la empresa",
    "How long?": "¿Durante cuánto tiempo?",
    "Invoice no.": "Factura N°.",
    "Login options": "Opciones de acceso",
    "Tenant ID (optional)": "ID del inquilino (opcional)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Añada el ID de inquilino de Active Directory, si sólo los usuarios pertenecientes a este inquilino pueden conectarse",
    "How to find ID’s?": "¿Cómo encontrar las identificaciones?",
    "Microsoft connected": "Microsoft conectado",
    "Google connected": "Google conectado",
    "Edit company": "Editar empresa",
    "Timezone": "Zona horaria",
    "Invoice email": "Correo electrónico de la factura",
    "Subscription plan": "Plan de suscripción",
    "Payment failed": "Pago fallido",
    "Retry payment": "Reintente el pago",
    "Next payment": "Próximo pago",
    "Update payment method": "Actualizar método de pago",
    "Plan": "Plan",
    "Choose a plan": "Elige un plan",
    "Change plan": "Cambiar de Plan",
    "{0}-day free trial until {1}": "prueba gratuita de {0}días hasta el {1}",
    "monthly": "mensualmente",
    "yearly": "anualmente",
    "{0} member": "{0} miembro",
    "{0} members": "{0} miembros",
    "{0} plan": "{0} plan",
    "Cancelled (valid until {0})": "Cancelado (válido hasta {0})",
    "Your trial expired on {0}": "Su periodo de prueba expiró el {0}",
    "Your subscription expired on {0}": "Su suscripción expiró el {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "¡Nos alegramos de verle! Si desea ponerse en marcha con una suscripción Uku, haga clic en Elegir un plan",
    "Save {0} by paying for a year!": "¡Ahorre {0} pagando un año!",
    "Choose plan": "Elegir plan",
    "Pay annually": "Pague anualmente",
    "Instructions sent!": "¡Instrucciones enviadas!",
    "Instructions for resetting your password have been sent to": "Las instrucciones para restablecer su contraseña se han enviado a",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Recibirá este correo electrónico en 5 minutos. Asegúrese también de revisar su carpeta de correo no deseado.",
    "Back to login page": "Volver a la página de inicio de sesión",
    "Get new password": "Recuperar contraseña",
    "Pick a password": "Escoja una contraseña",
    "Use minimum 8 characters with letters & numbers": "Utilice un mínimo de 8 caracteres con letras y números",
    "Create your Uku Account": "Cree su cuenta Uku",
    "Connect your Xero Account": "Conecte su cuenta Xero",
    "Phone": "Teléfono",
    "I agree to the": "Estoy de acuerdo con los",
    "Terms of Service": "Términos de Servicio",
    "Next": "Siguiente",
    "Having trouble?": "¿Le causa algún problema?",
    "We can help": "Podemos ayudar",
    "Log in instead": "Conéctese en su lugar",
    "You are invited to join": "Le invitamos a unirse a",
    "Accept invitation": "Aceptar invitación",
    "Check your email": "Consulte su correo electrónico",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Le he enviado un correo electrónico con un enlace para activar su cuenta. Esto es importante para garantizar la seguridad de su cuenta.",
    "Go to": "Ir",
    "Need a new password?": "¿Necesita una nueva contraseña?",
    "Enter your e-mail address and we will send you directions for changing your password": "Introduzca su dirección de correo electrónico y le enviaremos instrucciones para cambiar su contraseña",
    "Send me instructions": "Envíeme instrucciones",
    "Never mind, go back": "No importa, vuelve",
    "No login options enabled. Please contact the company owner": "No hay opciones de inicio de sesión habilitadas. Póngase en contacto con el propietario de la empresa",
    "Log in to Uku": "Conectarse a Uku",
    "Forgot password?": "¿Olvidaste tu contraseña?",
    "Don't have account?": "¿No tiene cuenta?",
    "Create account": "Crear una cuenta",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Herramienta nº 1 para prácticas contables. Flujos de trabajo automatizados, seguimiento del tiempo, informes, supervisión, CRM. Realice su trabajo a tiempo y de forma rentable. ¡Pruébelo gratis!",
    "Total items:": "Total de artículos:",
    "Add new": "Añadir nuevo",
    "Amount": "Cantidad",
    "Account created range": "Rango de creación de la cuenta",
    "Usage limit": "Límite de uso",
    "Valid until": "Válido hasta",
    "Edit help link": "Editar enlace de ayuda",
    "New help link": "Nuevo enlace de ayuda",
    "Name key": "Clave del nombre",
    "Country code": "Código del país",
    "Period (months)": "Período (meses)",
    "Account created from": "Cuenta creada a partir de",
    "Account created until": "Cuenta creada hasta",
    "Used count": "Recuento usado",
    "Free days": "Días libres",
    "Sum": "Suma",
    "Create voucher": "Crear vale",
    "Edit voucher": "Editar el cupón",
    "Are you sure to delete this voucher?": "¿Está seguro de eliminar este vale?",
    "row | rows": "fila | filas",
    "Add event": "Añadir evento",
    "Are you sure you wish to delete this event?": "¿Está seguro de que desea eliminar este evento?",
    "event | events": "evento | eventos",
    "Security object id": "Id. del objeto de seguridad",
    "Direct rights": "Derechos directos",
    "Computed rights": "Derechos computados",
    "Add link": "Añadir enlace",
    "Are you sure you wish to delete this entry?": "¿Está seguro de que desea borrar esta entrada?",
    "link | links": "enlace | enlaces",
    "Event type": "Tipo de evento",
    "Date from": "Fecha desde",
    "Date until": "Fecha hasta",
    "Shortened by h": "Acortado por h",
    "Category": "Categoría",
    "demo | demos": "demo | demos",
    "Created at": "Creado en",
    "Invited by": "Invitado por",
    "referral | referrals": "remisión | remisiones",
    "Companies": "Empresas",
    "Leads": "Clientes Potenciales",
    "Demos": "Demos",
    "Vouchers": "Vales",
    "KPI": "Kpi",
    "Referrals": "Referidos",
    "Activity log": "Registro de actividad",
    "Notifications": "Notificaciones",
    "Me": "Mi",
    "Important notifications will appear here.": "Las notificaciones importantes aparecerán aquí.",
    "Back": "Volver",
    "Return to UKU": "Volver a UKU",
    "Choose plan for {0}": "Elija plan para {0}",
    "First payment will be made after the end of the trial period.": "El primer pago se efectuará una vez finalizado el periodo de prueba.",
    "Members and subscription can always be changed.": "Los miembros y la suscripción siempre se pueden cambiar.",
    "Your subscription is externally managed by Xero": "Su suscripción es gestionada externamente por Xero",
    "Select plan": "Seleccione plan",
    "Billing period": "Periodo de facturación",
    "Compare features": "Comparar características",
    "Cancel uku subscription": "Cancelar la suscripción a uku",
    "{0} discount": "{0} descuento",
    "You have currently<br />{0} active member": "Actualmente tiene<br />{0} miembro activo",
    "You have currently<br />{0} active members": "Actualmente tiene<br />{0} miembros activos",
    "Select yearly plan": "Seleccione el plan anual",
    "Select monthly plan": "Seleccione el plan mensual",
    "Attention!": "Atención!",
    "Plan change request": "Solicitud de cambio de plan",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Si desea utilizar Uku de forma gratuita entonces desactive su cuenta y continúe con el plan {0}",
    "per member/month (billed yearly)": "por afiliado/mes (facturado anualmente)",
    "or {0} per member/month (monthly)": "o {0} por afiliado/mes (mensual)",
    "Everything in {0}, plus:": "Todo en {0}, además:",
    "Compare plans, feature-by-feature": "Comparar planes, característica por característica",
    "Deactivate account": "Desactivar cuenta",
    "Are you sure to deactivate {0} account?": "¿Está seguro de desactivar la cuenta {0}?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Si decide continuar con el plan freelancer su cuenta de empresa será desactivada. Los datos relacionados con esta empresa serán eliminados.",
    "Deactivate": "Desactivar",
    "Teamwork": "Trabajo en equipo",
    "Unlimited clients + import": "Clientes ilimitados + importación",
    "Access management": "Gestión de Accesos",
    "Custom fields": "Campos personalizados",
    "Live chat support": "Asistencia por chat en directo",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Portal del cliente",
    "New!": "¡Nuevo!",
    "Custom integrations": "Integraciones personalizadas",
    "Assisted clients import": "Ayudó a los clientes a importar",
    "Tailor-made team workshop": "Taller de equipo a medida",
    "Early access to features": "Acceso anticipado a las funciones",
    "Pay by invoice": "Pagar con factura",
    "Dedicated account manager": "Gestor de cuentas dedicado",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Hola, su periodo de prueba ha terminado. Por favor, elija el plan de suscripción {0} para continuar trabajando",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Hola! Necesita actualizar el plan de suscripción {0} para utilizar esa función",
    "Waiting for the subscription to complete": "Esperando a que se complete la suscripción",
    "VAT": "IVA",
    "This is subscription period amount.": "Es el importe del periodo de suscripción.",
    "You save yearly {0}": "Usted ahorra anualmente {0}",
    "Add voucher": "Añadir vale",
    "Existing credit": "Crédito existente",
    "Current payment": "Pago actual",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Este es el importe de pago actual. Su banco también requiere confirmación para el importe del periodo de suscripción.",
    "Confirm subscription {0}": "Confirmar suscripción {0}",
    "Your subscription will renew on": "Su suscripción se renovará el",
    "Thank you for believing in us!": "¡Gracias por creer en nosotros!",
    "Uku team": "Equipo Uku",
    "Voucher {1} (-{0}%)": "Vale {1} (-{0}%)",
    "Voucher {0}": "Vale {0}",
    "New plan": "Nuevo plan",
    "Changed plan": "Plan modificado",
    "Add {0} member": "Añadir miembro {0}",
    "Add {0} members": "Añadir {0} miembros",
    "Remove {0} member": "Eliminar miembro {0}",
    "Remove {0} members": "Eliminar {0} miembros",
    "No changes to plan": "Sin cambios en el plan",
    "Discount -{0}% with Yearly subscription": "Descuento -{0}% con suscripción anual",
    "Yearly discounted price (-{0}%)": "Precio anual con descuento (-{0}%)",
    "Subscription updated": "Suscripción actualizada",
    "Please wait": "Por favor, espere",
    "Your payment failed": "Tu pago no se ha realizado",
    "Please check that you entered the data correctly or use another card": "Por favor, compruebe que ha introducido los datos correctamente o utilice otra tarjeta",
    "Try again": "Inténtalo de nuevo",
    "Pay": "Pagar",
    "Payment": "Pago",
    "Payment method updated": "Forma de pago actualizada",
    "Edit member": "Editar miembros",
    "First name": "Nombre",
    "Last name": "Apellido",
    "External ID": "ID externo",
    "Select groups": "Seleccione Grupos",
    "Administrator": "Administrador",
    "Activate member": "Activar miembro",
    "Deactivate member": "Desactivar miembro",
    "Paid member": "Miembro de pago",
    "Send an invitation": "Enviar una invitación",
    "Limited": "Limitada",
    "No invite, no access": "Sin invitación, no hay acceso",
    "Free until activated": "Gratis hasta que se active",
    "No access, no charge": "Sin acceso, sin cargo",
    "Hidden member": "Miembro oculto",
    "Edit members": "Editar miembros",
    "Select user": "Seleccionar Usuario",
    "Member will be assigned to every selected client": "Se asignará un miembro a cada cliente seleccionado",
    "Member will be removed from all selected clients": "El miembro será eliminado de todos los clientes seleccionados",
    "Assign user": "Asignar Usuario",
    "Set as primary user": "Establecer como usuario principal",
    "Added as a default user when adding a task plan": "Añadido como usuario por defecto al añadir un plan de tareas",
    "Remove from new tasks": "Eliminar de nuevas tareas",
    "Remove from plan tasks": "Eliminar tareas del plan",
    "Remove": "Eliminar",
    "Admin": "Administrador",
    "Remove user": "Eliminar usuario",
    "Assign to incomplete tasks": "Asignar a tareas incompletas",
    "Reassign incomplete tasks": "Reasignar tareas incompletas",
    "Assign to plan tasks": "Asignar para planificar tareas",
    "Reassign plan tasks": "Reasignar tareas del plan",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "El propietario será asignado a las tareas si el usuario eliminado fue el último usuario asignado.",
    "Run integration": "Ejecutar la integración",
    "Run": "Ejecutar",
    "Integration configuration": "Configuración de la integración",
    "Read the manual": "Lea el manual",
    "Api key": "Clave de API",
    "Are you sure to delete this integration info?": "¿Está seguro de eliminar esta información de integración?",
    "Edit Contracts": "Editar contratos",
    "Replace following contracts": "Sustituir los siguientes contratos",
    "Append services to following contracts": "Anexar servicios a los siguientes contratos",
    "Choose template": "Plantilla para título de evento",
    "Append only": "Añadir sólo",
    "with template": "con plantilla",
    "All existing contracts": "Todos los contratos existentes",
    "All quarterly contracts": "Todos los contratos trimestrales",
    "All monthly contracts": "Todos los contratos mensuales",
    "All yearly contracts": "Todos los contratos anuales",
    "Next invoice number": "Siguiente número de factura",
    "Number is too big, it cannot exceed 15 digits": "El número es demasiado grande, no puede superar los 15 dígitos",
    "Replace topic": "Sustituir tema",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Todas las tareas y planes con el tema actual serán sustituidos por el nuevo tema seleccionado.",
    "Topics replaced": "Temas sustituidos",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Todas las tareas con el tema `{0}` serán sustituidas por `{1}`. Esto no es reversible. ¿Está seguro?",
    "Name of topic": "Nombre del tema",
    "New time entries will be marked as non-billable": "Las nuevas entradas de tiempo se marcarán como no facturables",
    "Change topic": "Cambiar de tema",
    "Add new topic": "Agregar nuevo tema",
    "This topic is in use. Do you wish to archive it?": "Este tema está en uso. ¿Desea archivarlo?",
    "Are you sure that you want to delete this topic?": "¿Está seguro de que desea borrar este tema?",
    "These items will be deleted permanently": "Estos elementos se eliminarán de forma permanente",
    "Are you sure that you want to delete this client group?": "¿Está seguro de que desea eliminar este grupo de clientes?",
    "This client group is in use. Do you wish to archive it?": "Este grupo de clientes está en uso. ¿Desea archivarlo?",
    "Edit client group": "Editar grupo de clientes",
    "New client group": "Nuevo grupo de clientes",
    "Price": "Precio",
    "Quantity": "Cantidad",
    "Unit will be translated to client language": "La unidad se traducirá al idioma del cliente",
    "Pick date & time": "Fecha y hora de recogida",
    "Share equally": "Compartir igualmente",
    "Change existing": "Cambiar los existentes",
    "Choose bookmark": "Elija el marcador",
    "New title": "Nuevo título",
    "Set as my default view": "Establecer como mi vista por defecto",
    "Signature name": "Nombre de la firma",
    "Layout": "Diseño",
    "Top": "Arriba",
    "Middle": "Medio",
    "Bottom": "Abajo",
    "Logo left": "Logotipo de la izquierda",
    "Logo top": "Logotipo superior",
    "No logo": "Sin logotipo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Firma de correo electrónico",
    "Edit email signature": "Editar la firma del correo electrónico",
    "Add email signature": "Añadir firma de correo electrónico",
    "Font color": "Color de fuente",
    "Actions": "Acciones",
    "Delete signature": "Borrar firma",
    "Do you wish to update related contracts and invoices?": "¿Desea actualizar los contratos y facturas relacionados?",
    "Update contract templates, active contracts and open invoices.": "Actualice las plantillas de contratos, los contratos activos y las facturas abiertas.",
    "The following fields will be updated": "Se actualizarán los siguientes campos",
    "Custom Value": "Valor personalizado",
    "This product is in use. Do you wish to archive it?": "Este producto está en uso. ¿Desea archivarlo?",
    "Are you sure that you want to delete this product?": "¿Está seguro de que desea eliminar este producto?",
    "Customize for client": "Personalizar para el cliente",
    "Customize for template": "Personalizar para plantilla",
    "Open product template": "Abrir plantilla de producto",
    "Create product template": "Crear plantilla de producto",
    "Master template": "Plantilla maestra",
    "Client product": "Producto cliente",
    "Client product / service": "Producto / servicio del cliente",
    "New client product": "Nuevo producto cliente",
    "Template product": "Plantilla de producto",
    "Template product / service": "Plantilla producto / servicio",
    "New template product": "Nuevo producto de plantilla",
    "Edit translations": "Editar traducciones",
    "Billable topics": "Temas facturables",
    "Billable time": "Tiempo facturable",
    "Minimum quantity": "Cantidad mínima",
    "Minimum time": "Tiempo mínimo",
    "Integration parameters": "Parámetros de integración",
    "Empty values will use product default": "Los valores vacíos utilizarán el producto por defecto",
    "Pricing": "Precios",
    "DC %": "DC %",
    "Sum all matching rows": "Suma todas las filas coincidentes",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Cuando está activado, el precio total es una suma acumulativa de todas las filas coincidentes. Por defecto, el precio total sólo utiliza la fila coincidente más alta.",
    "Prices since": "Precios desde",
    "Add price": "Añadir precio",
    "Add pricing period": "Añadir período de tarificación",
    "Update contracts": "Actualizar contratos",
    "(Without topic)": "(Sin tema)",
    "Fixed price": "Precio fijo",
    "Product": "Producto",
    "Event created": "Actividad creada",
    "Project created": "Proyecto creado",
    "Event deleted": "Actividad eliminada",
    "Project deleted": "Proyecto eliminado",
    "Workflow added": "Flujo de trabajo añadido",
    "Workflow removed": "Flujo de trabajo eliminado",
    "Workflow updated": "Flujo de trabajo actualizado",
    "Event cancelled": "Evento cancelado",
    "Project cancelled": "Proyecto cancelado",
    "Event reactivated": "Evento reactivado",
    "Project reactivated": "Proyecto reactivado",
    "Event archived": "Evento archivado",
    "Project archived": "Proyecto archivado",
    "Event unarchived": "Evento no archivado",
    "Project unarchived": "Proyecto sin archivar",
    "Event changed": "Evento modificado",
    "Project changed": "Proyecto modificado",
    "Event status changed: {0}": "Estado del suceso cambiado: {0}",
    "Project status changed: {0}": "Estado del proyecto modificado: {0}",
    "Event status changed": "Estado del evento cambiado",
    "Project status changed": "Cambio de estado del proyecto",
    "Task created": "Tarea creada",
    "Task changed": "Tarea modificada",
    "Task finished": "Tarea terminada",
    "Task not finished": "Tarea no finalizada",
    "Task deleted": "Tarea borrada",
    "Add project": "Añadir proyecto",
    "Hide filters": "Ocultar filtros",
    "Show filters": "Mostrar filtros",
    "Cancel event": "Cancelar evento",
    "Cancel project": "Cancelar proyecto",
    "Manage event fields": "Gestionar campos de eventos",
    "Manage project fields": "Gestionar los campos del proyecto",
    "New event": "Nuevo evento",
    "New project": "Nuevo proyecto",
    "{0} (Copy)": "{0} (Copia)",
    "Are you sure you wish to delete this project?": "¿Está seguro de que desea eliminar este proyecto?",
    "Are you sure to archive this event?": "¿Está seguro de archivar este evento?",
    "Are you sure to archive this project?": "¿Está seguro de archivar este proyecto?",
    "Are you sure to cancel this event?": "¿Está seguro de cancelar este evento?",
    "Are you sure to cancel this project?": "¿Está seguro de cancelar este proyecto?",
    "Communication": "Comunicación",
    "Log": "Registro",
    "Create event workflow": "Crear flujo de trabajo de eventos",
    "Create project workflow": "Crear el flujo de trabajo del proyecto",
    "Use workflow templates to set up tasks effectively or": "Utilice plantillas de flujo de trabajo para configurar las tareas de forma eficaz o",
    "Add tasks manually": "Añadir tareas manualmente",
    "Save bookmark": "Guardar marcador",
    "Remove filters": "Eliminar los filtros",
    "Filter": "Filtro",
    "Show multiselect": "Mostrar multiselección",
    "To do today": "Para hacer hoy",
    "This and next month": "Este mes y el próximo",
    "Last 3 months": "Últimos 3 meses",
    "Next 3 months": "Próximos 3 meses",
    "Starts": "Empieza",
    "To do": "Por hacer",
    "today": "hoy",
    "tomorrow": "mañana",
    "yesterday": "ayer",
    "Previous week": "Semana anterior",
    "Group similar tasks": "Agrupar tareas similares",
    "Group by client": "Agrupar por cliente",
    "Group by date": "Agrupar por fecha",
    "Group by topic": "Agrupar por temas",
    "Are you sure to remove google?": "¿Está seguro de eliminar google?",
    "Google log in": "Inicio de sesión en Google",
    "Microsoft log in": "Inicio de sesión de Microsoft",
    "Are you sure to remove microsoft?": "¿Está seguro de eliminar microsoft?",
    "Are you want to disconnect Xero?": "¿Quieres desconectar Xero?",
    "Reset password": "Restablecer contraseña",
    "Your details": "Tus detalles",
    "City": "Ciudad",
    "Regional format": "Formato regional",
    "Default company": "Empresa por defecto",
    "Lock time entries notification": "Notificación de entradas de tiempo de bloqueo",
    "Notify by": "Notificar por",
    "Delete my account": "Borrar mi cuenta",
    "Attention": "Atención",
    "Are you sure that you want to delete your account?": "¿Está seguro de que desea eliminar su cuenta?",
    "Notification": "Notificación",
    "Notification & email": "Notificación y correo electrónico",
    "Vacations / absence": "Vacaciones / ausencia",
    "Edit balance": "Editar balance",
    "View history": "Ver historial",
    "Request": "Solicitud",
    "How long": "Cuánto tiempo",
    "Requested": "Solicitado",
    "Approved": "Aprobado",
    "Rejected": "Rechazado",
    "In review": "En revisión",
    "Change": "Cambiar",
    "Agreements": "Acuerdos",
    "New agreement": "Nuevo acuerdo",
    "Change agreement": "Acuerdo de modificación",
    "Stop demo": "Detener la demostración",
    "Show": "Mostrar",
    "Don't show": "No mostrar",
    "Don't send": "No enviar",
    "Email workdays at 7 AM": "Días laborables por correo electrónico a las 7 AM",
    "Email at 3 PM": "Correo electrónico a las 15.00 horas",
    "Email at once": "Correo electrónico de una vez",
    "Email Sundays at 11 PM": "Correo electrónico los domingos a las 23 horas",
    "First day of the month": "Primer día del mes",
    "to email": "al correo electrónico",
    "E-mail at once": "Correo electrónico",
    "System": "Sistema",
    "Person": "Persona",
    "Picture": "Foto",
    "Time zone": "Zona Horaria",
    "Calendar settings": "Ajustes del calendario",
    "Public holidays": "Días festivos",
    "Tax deadlines": "Plazos fiscales",
    "News": "Noticias",
    "External services": "Servicios externos",
    "Agreement": "Acuerdo",
    "Active agreement": "Acuerdo activo",
    "Weekly hours": "Horas semanales",
    "Edit supplier": "Editar proveedor",
    "New supplier": "Nuevo proveedor",
    "Are you sure you wish to delete this supplier?": "¿Está seguro de que desea eliminar a este proveedor?",
    "Add supplier": "Añadir proveedor",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Los tipos de proveedores no están definidos. Vaya a la configuración de la aplicación de proveedores para añadirlos.",
    "No members yet": "Todavía no hay interesados",
    "Edit group": "Editar grupo",
    "Add group": "Añadir grupo",
    "Are you sure to delete this user group?": "¿Está seguro de eliminar este grupo de usuarios?",
    "Get set up to work with team": "Prepárese para trabajar en equipo",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "La cuenta de empresa le permite utilizar herramientas para equipos, obtener información más detallada, etc. Eleve la calidad del flujo de trabajo de su equipo y dirija un negocio más rentable.",
    "Create company account": "Crear cuenta de empresa",
    "By creating a company account you activate Uku free subscription for {0} days.": "Al crear una cuenta de empresa activa la suscripción gratuita a Uku durante {0} días.",
    "You have invited {0}/{1} members": "Ha invitado a {0}/{1} miembros",
    "Upgrade": "Actualizar",
    "View profile": "Ver perfil",
    "To add members to your team, you'll need to create a company account": "Para añadir miembros a su equipo, deberá crear una cuenta de empresa",
    "Export": "Exportar",
    "Re-invite sent": "Re-invitación enviada",
    "View report": "Ver informe",
    "Member {0} will be deactivated.": "El miembro {0} será desactivado.",
    "Please select new member who will replace {0}.": "Por favor, seleccione al nuevo miembro que sustituirá a {0}.",
    "Select new member": "Seleccionar nuevo miembro",
    "NB! Deactivation process cannot be reversed": "¡NB! El proceso de desactivación no se puede revertir",
    "Magic button settings": "Ajustes del botón mágico",
    "Create only one task per month": "Cree sólo una tarea al mes",
    "Current month's tasks": "Tareas del mes en curso",
    "extra work": "trabajo extra",
    "Without topic": "Sin tema",
    "Week": "Semana",
    "Previous month": "Mes anterior",
    "task | tasks": "tarea | tareas",
    "Assign to": "Asignar a",
    "Mark as done": "Marcar como hecho",
    "Last": "Último",
    "Snooze": "Posponer",
    "1 dependency": "1 dependencia",
    "{0} dependencies": "{0} dependencias",
    "Client request": "Solicitud del cliente",
    "Unread notification emails": "Correos electrónicos de notificación no leídos",
    "Unread internal comments": "Comentarios internos no leídos",
    "Add comment": "Añadir comentario",
    "Internal comment": "Comentario interno",
    "Portal message": "Mensaje del portal",
    "Public message means that clients can read it and the client portal will notify them by email": "Mensaje público significa que los clientes pueden leerlo y el portal de clientes les notificará por correo electrónico",
    "Type a comment": "Escriba un comentario",
    "Send portal message": "Enviar mensaje al portal",
    "Open timesheet": "Abrir hoja de horas",
    "Pause timer": "En línea",
    "Mark undone": "Marca deshecha",
    "Digitise": "Digitalice",
    "Documents sent to digitisation": "Documentos enviados a digitalización",
    "Followers": "Seguidores",
    "Start / Due date": "Fecha de inicio / vencimiento",
    "Select topic": "Seleccione un tema",
    "1 document": "1 documento",
    "{0} documents": "{0} documentos",
    "Download": "Descargar",
    "Download all": "Descargar todos",
    "Primary contact": "Contacto principal",
    "Assign as task": "Asignar como tarea",
    "When selected, the task is sent as a task to the client": "Cuando se selecciona, la tarea se envía como tarea al cliente",
    "Auto finish": "Acabado automático",
    "When selected, the task is marked done after client finishes it": "Cuando se selecciona, la tarea se marca como realizada cuando el cliente la finaliza",
    "Add comment / message": "Añadir comentario / mensaje",
    "Add email": "Añadir email",
    "Add estimation": "Añadir estimación",
    "Add task field": "Añadir campo de tarea",
    "Add dependency": "Agregar dependencia",
    "Drop files to upload": "Arrastre los datos para cargar",
    "Task sent to client portal": "Tarea enviada al portal del cliente",
    "Task no longer assigned to client portal": "Tarea ya no asignada al portal del cliente",
    "Save recurring task": "Guardar tarea recurrente",
    "Add to-do list": "Añadir lista de tareas",
    "Waiting for event status: {0}": "Esperando el estado del evento: {0}",
    "Waiting for project status: {0}": "Esperando el estado del proyecto: {0}",
    "Edit template task": "Editar tarea de plantilla",
    "Create recurring task": "Crear tarea recurrente",
    "Make a copy": "Hacer una copia",
    "Add topic": "Añadir tema",
    "Delete task": "Borrar tarea",
    "Delete task template": "Borrar plantilla de tarea",
    "Select task field": "Seleccionar campo de tarea",
    "No custom fields available for this client": "No hay campos personalizados disponibles para este cliente",
    "task": "tarea",
    "recurring task": "tarea recurrente",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "¿Tiene intención de borrarse de {0} o quiere eliminarlo por completo?",
    "This {1} is shared with {0}": "Este {1} se comparte con el {0}",
    "Remove only me": "Eliminar sólo a mí",
    "Time has been tracked to this task.": "Se ha dedicado tiempo a esta tarea.",
    "Are you sure to delete this task?": "¿Seguro de eliminar esta actividad?",
    "Undefined": "Indefinido",
    "COPY": "COPIA",
    "On task due date": "En la fecha de vencimiento de la tarea",
    "{0} day before": "{0} día anterior",
    "{0} days before": "{0} días antes",
    "Edit workflow": "Editar el flujo de trabajo",
    "Duplicate project": "Duplicar proyecto",
    "Reset layout": "Restablecer el diseño",
    "Any time": "En cualquier momento",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 h",
    "Add notes": "Añade notas",
    "Task start date": "Fecha de Inicio de la tarea",
    "Task due date": "Fecha de vencimiento de la tarea",
    "Recurrence task": "Tarea de recurrencia",
    "Search from one time templates": "Búsqueda a partir de plantillas únicas",
    "Placeholders": "Marcadores de contenido",
    "New task": "Nueva tarea",
    "New recurring task": "Nueva tarea recurrente",
    "+1 day": "+1 Día",
    "Edit comment": "Editar comentario",
    "Timer is running!": "¡El temporizador está en marcha!",
    "Continue time from {0}": "Continuar el tiempo desde {0}",
    "New time entry": "Nueva entrada de tiempo",
    "Load more": "Cargar más",
    "Are you sure to delete this time entry?": "¿Está seguro de eliminar esta entrada de tiempo?",
    "Save automated email": "Guardar correo electrónico automatizado",
    "Automation": "Automatización",
    "Are you sure to delete this email?": "¿Está seguro de borrar este correo electrónico?",
    "Are you sure you wish to send this email immediately?": "¿Está seguro de que desea enviar este correo electrónico inmediatamente?",
    "replied to project email": "respondió al correo electrónico del proyecto",
    "replied to client email": "respondió al correo electrónico del cliente",
    "commented": "comentó",
    "Reply": "Responder",
    "Are you sure to delete this comment?": "¿Seguro de eliminar este comentario?",
    "replied to client portal email": "respondió al correo electrónico del portal del cliente",
    "sent a message": "envió un mensaje",
    "replied to task email": "respondió al correo electrónico de la tarea",
    "failed to send": "fallo en el envío",
    "sent email": "correo electrónico enviado",
    "no one": "Nadie",
    "created this task.": "creó esta tarea.",
    "Task was automatically created from forwarded e-mail": "La tarea se creó automáticamente a partir de un correo electrónico reenviado",
    "Task was automatically created from client portal e-mail": "La tarea se creó automáticamente a partir del correo electrónico del portal del cliente",
    "Task was automatically created from client e-mail": "La tarea se creó automáticamente a partir del correo electrónico del cliente",
    "Task was automatically created from project e-mail": "La tarea se creó automáticamente a partir del correo electrónico del proyecto",
    "requested assistance.": "asistencia solicitada.",
    "updated this task.": "actualizado esta tarea.",
    "tracked time to this task.": "tiempo dedicado a esta tarea.",
    "finished this task.": "terminado esta tarea.",
    "new comment.": "nuevo comentario.",
    "reassigned this task.": "reasignado esta tarea.",
    "assigned the task to {0}.": "asignó la tarea a {0}.",
    "reminder.": "recordatorio.",
    "deleted.": "borrado.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "completó la tarea, pero Uku no la autoconcluyó porque no se cumplían todos los requisitos de la tarea.",
    "sent task to client portal": "tarea enviada al portal del cliente",
    "assigned the task to client.": "asignó la tarea al cliente.",
    "assigned the task to company.": "asignó la tarea a la empresa.",
    "added attachment(s).": "anexo(s) añadido(s).",
    "added a comment.": "ha añadido un comentario.",
    "added a message to {0}.": "ha añadido un mensaje a {0}.",
    "received a e-mail from {0}.": "ha recibido un correo electrónico de {0}.",
    "updated notes.": "notas actualizadas.",
    "made changes to checklist.": "realizado cambios en la lista de comprobación.",
    "created this task template.": "creó esta plantilla de tareas.",
    "updated this task template.": "actualizado este modelo de tarea.",
    "recurring task assigned.": "tarea recurrente asignada.",
    "recurring task deleted.": "tarea recurrente eliminada.",
    "added email.": "correo electrónico añadido.",
    "changed email.": "cambió de correo electrónico.",
    "deleted email.": "correo electrónico eliminado.",
    "sent email.": "enviado correo electrónico.",
    "failed to send.": "no se ha podido enviar.",
    "added email": "correo electrónico añadido",
    "changed email": "correo electrónico modificado",
    "deleted email": "correo electrónico eliminado",
    "Member / Time": "Miembro / Hora",
    "Client/topic": "Cliente/tema",
    "Client/task": "Cliente/tarea",
    "Client/member": "Cliente/miembro",
    "Member/topic": "Miembro/tema",
    "Member/task": "Miembro/tarea",
    "Member/client": "Miembro/cliente",
    "Member/date": "Miembro/fecha",
    "Date/member": "Fecha/miembro",
    "Grouped": "Agrupado",
    "Client/project": "Cliente/proyecto",
    "Project/member": "Proyecto/miembro",
    "Period balance": "Saldo del período",
    "Reset balance": "Restablecer el equilibrio",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Se ha confirmado la entrada de tiempo o se ha modificado la duración y ésta no se actualizará dinámicamente",
    "(Without project)": "(Sin proyecto)",
    "Decline": "Rechazar",
    "Accept": "Aceptar",
    "Cancel decision": "Cancelar decisión",
    "Accepted": "Aceptado",
    "Declined": "Rechazado",
    "Report data has changed. Please update report.": "Los datos del informe han cambiado. Por favor, actualice el informe.",
    "Agreed": "Acuerdo",
    "Non billable": "No facturable",
    "Estimation report shows based on task start date": "El informe de estimación se muestra en función de la fecha de inicio de la tarea.",
    "Export report to Excel": "Exportar informe a Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "Por defecto, exportamos el resultado de los filtros seleccionados con las columnas de la tabla configurada",
    "Add to export client custom fields": "Añadir a la exportación campos personalizados del cliente",
    "Save report": "Guardar informe",
    "Export PDF": "Exportar a PDF",
    "Export Excel": "Exportar a Excel",
    "Extra": "Extra",
    "done": "hecho",
    "h": "h",
    "We have new version of": "Disponemos de una nueva versión de",
    "Log out": "Cerrar sesión",
    "Previous day": "Día anterior",
    "Next day": "Siguiente dia",
    "Mark all as read": "Marcar todos como leídos",
    "Search task/client": "Buscar tarea/cliente",
    "from client portal": "desde el portal del cliente",
    "Hide all": "Hide All",
    "Hide for 1 hour": "Ocultarse durante 1 hora",
    "Something went wrong": "Algo salió mal",
    "User authentication needed": "Es necesaria la autenticación del usuario",
    "Invalid rights": "Derechos no válidos",
    "The object cannot be found": "No se puede encontrar el objeto",
    "Content too large": "Contenido demasiado grande",
    "An unknown error occurred": "Ocurrió un error desconocido",
    "The action requested cannot be performed": "La acción solicitada no puede realizarse",
    "Go": "Ir",
    "Actual / monitoring (month)": "Real / seguimiento (mes)",
    "Actual": "Actual",
    "Month": "Mes",
    "I’m setting up your account": "Estoy configurando su cuenta",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "¿Sabía que las empresas de contabilidad que han empezado a utilizar Uku pueden atender a un 38% más de clientes en el mismo tiempo?",
    "Let’s setup your company": "Configuremos su empresa",
    "Name of your company": "Nombre comercial de tu empresa",
    "Size of your team?": "¿Tamaño de su equipo?",
    "Which software are you using?": "¿Qué software utiliza?",
    "This knowledge will help us to improve Uku": "Estos conocimientos nos ayudarán a mejorar Uku",
    "What other software needs to be integrated?": "¿Qué otro software es necesario integrar?",
    "Book a demo": "Reserve una demostración",
    "Hi {0},": "Hola {0},",
    "NO BOTS - ONLY HUMANS": "NO BOTS - SÓLO HUMANOS",
    "Start a {0} day free trial": "Inicie una prueba gratuita de {0} días",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "\"Uku es un software increíblemente funcional. Uku ha impulsado nuestra gestión del trabajo y nos ayuda a ofrecer un servicio excepcional.\"",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "La forma más rápida de decidir si Uku puede beneficiarle {0} es una breve llamada de {1} minutos con nuestro especialista en incorporación de clientes.",
    "Hi, I'm Uku ": "Hola, soy Uku",
    "I help to set up your account.": "Le ayudo a configurar su cuenta.",
    "It only takes a minute.": "Sólo le llevará un minuto.",
    "Choose": "Elegir",
    "Your country": "Su país",
    "Your language": "Su lengua",
    "Begin": "Comenzar",
    "Let’s become friends": "Hagámonos amigos",
    "Your first name": "Su nombre",
    "What is your field of work?": "¿Cuál es su campo de trabajo?",
    "Your field of work": "Su campo de trabajo",
    "How will you use Uku?": "¿Cómo utilizará Uku?",
    "How did you hear about Uku?": "¿Cómo conoció Uku?",
    "Choose channel": "Elija el canal",
    "Please specify how you heard about us": "Especifique cómo nos conoció",
    "Let me know Uku's new features by email": "Comuníqueme las novedades de Uku por correo electrónico",
    "Finish": "Terminar",
    "First name is required": "El nombre es necesario",
    "Name is required": "El nombre es obligatorio",
    "Team size is required": "Se requiere el tamaño del equipo",
    "Surname is required": "El apellido es obligatorio",
    "Field is required": "Campo obligatorio",
    "I will use Uku to work together with two or more teammates.": "Utilizaré Uku para trabajar junto con dos o más compañeros de equipo.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Utilizaré Uku por mi cuenta. Este plan es gratuito, pero las funciones son limitadas.",
    "Media": "Media",
    "Through integration partner": "A través del socio integrador",
    "Referral by friend": "Recomendación de un amigo",
    "Import speeds up your clients setup, smart choice!": "La importación acelera la configuración de sus clientes, ¡una elección inteligente!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Última importación: añadido {0}, actualizado {1}, omitido {2}, fallo al importar {3} cliente",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Última importación: añadido {0}, actualizado {1}, omitido {2}, no se ha podido importar {3} clientes",
    "Last import: added {0}, updated {1}, skipped {2}": "Última importación: añadido {0}, actualizado {1}, omitido {2}",
    "What's next? Correct the data of {0} clients and upload again.": "¿Y ahora qué? Corrija los datos de los clientes {0} y vuelva a cargarlos.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX)",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "En lugar de introducir los clientes uno a uno, puede utilizar la importación de archivos para una gran base de clientes.",
    "Ignore": "Ignorar",
    "NEW CLIENT": "NUEVO CLIENTE",
    "Preview": "Vista previa",
    "Import started": "La importación ha iniciado …",
    "Only new clients": "Sólo nuevos clientes",
    "Update data from company register": "Actualizar los datos del registro mercantil",
    "If switched on, the company data is updated using the local business register": "Si está activada, los datos de la empresa se actualizan utilizando el registro mercantil local",
    "We did not find a match in Äriregister": "No encontramos ninguna coincidencia en Äriregister",
    "We did not find a match in Companies House": "No encontramos ninguna coincidencia en el Registro Mercantil",
    "No integration yet": "Aún no hay integración",
    "Uku match": "Partido Uku",
    "Business register nr.": "Nº de registro mercantil",
    "Company register": "Registro mercantil",
    "Upload file": "Subir archivo",
    "Before uploading your file": "Antes de cargar su archivo",
    "Learn Uku’s data structure": "Aprender la estructura de datos de Uku",
    "Download and use our sample file to see exactly how we organize data in Uku": "Descargue y utilice nuestro archivo de muestra para ver exactamente cómo organizamos los datos en Uku",
    "Download Client Import Example": "Descargar ejemplo de importación de clientes",
    "Download Contact Import Example": "Descargar ejemplo de importación de contactos",
    "Fill in fields": "Rellene los campos",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "El único campo obligatorio es el nombre de la empresa. Asegúrese de haber rellenado todos los campos necesarios antes de cargar el archivo.",
    "Learn more about mandatory fields": "Más información sobre los campos obligatorios",
    "Create custom fields": "Crear campo personalizado",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Es posible que algunos campos de datos no estén presentes por defecto. Asegúrese de crear estos campos personalizados antes de importar los datos.",
    "Add new custom fields": "Añadir nuevos campos personalizados",
    "...or drag a file here": "...o arrastre un archivo aquí",
    "Only Excel (.xls, .xlsx) file types are supported": "Sólo se admiten los tipos de archivo Excel (.xls, .xlsx)",
    "Mapping": "Mapeo",
    "First row is a header": "La primera fila es una cabecera",
    "Add field to all clients": "Añadir campo a todos los clientes",
    "Add client group": "Añadir grupo de clientes",
    "Fields for all clients": "Campos para todos los clientes",
    "Import of {0} in progress": "Importación de {0} en curso",
    "Import in progress": "Importación en progreso",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Puede llevar algún tiempo. Puede realizar otras actividades en Uku al mismo tiempo, le avisaremos cuando esté listo.",
    "Cancel import": "Cancelar la importación",
    "Are you sure you want to cancel import?": "¿Está seguro de que desea cancelar la importación?",
    "Last updated": "Última actualización",
    "Contracts": "Contratos",
    "Job name": "Nombre del ejercicio",
    "Workflow name": "Nombre del flujo de trabajo",
    "Details": "Detalles",
    "Select jobs": "Seleccionar trabajos",
    "Select task plan": "Seleccionar plan de tareas",
    "of existing client": "del cliente existente",
    "You can also choose": "También puede elegir",
    "existing client tasks plan": "plan de tareas del cliente existente",
    "existing predefined jobs": "trabajos predefinidos existentes",
    "create a new plan": "crear un nuevo plan",
    "Select workflow": "Seleccionar flujo de trabajo",
    "existing project workflow": "flujo de trabajo del proyecto existente",
    "existing workflow": "flujo de trabajo existente",
    "create a new workflow": "crear un nuevo flujo de trabajo",
    "New tasks template": "Nueva plantilla de tareas",
    "to save template!": "¡para guardar la plantilla!",
    "You can also add tasks from jobs": "También puede añadir tareas desde trabajos",
    "or choose": "o elija",
    "New workflow template": "Nueva plantilla de flujo de trabajo",
    "You can also add tasks from existing workflow templates": "También puede añadir tareas desde plantillas de flujo de trabajo existentes",
    "existing event workflow": "flujo de trabajo de eventos existente",
    "Hide others": "Ocultar otros",
    "Update all events (New tasks)": "Actualizar todos los eventos (Nuevas tareas)",
    "Update all projects (New tasks)": "Actualizar todos los proyectos (Nuevas tareas)",
    "Once": "Una vez",
    "Once a month": "Una vez al mes",
    "Once a quarter": "Una vez cada trimestre",
    "Once a year": "Una vez al año",
    "Company workflow": "Flujo de trabajo de la empresa",
    "Company jobs": "Empleos en empresas",
    "Default jobs": "Trabajos por defecto",
    "ID": "ID",
    "Task title and labels": "Título de la tarea y etiquetas",
    "Assigned and time": "Asignado y hora",
    "Setup tasks for {0} event": "Tareas de configuración para el evento {0}",
    "Setup tasks for {0} project": "Configurar tareas para el proyecto {0}",
    "New job": "Nueva oferta",
    "Edit job": "Editar trabajo",
    "New workflow": "Nuevo flujo de trabajo",
    "Save workflow": "Guardar flujo de trabajo",
    "Confirm task plan": "Confirmar el plan de tareas",
    "Skip": "Saltar",
    "Create task plan": "Crear un plan de tareas",
    "Edit task plan": "Editar el plan de tareas",
    "Confirm workflow": "Confirme el flujo de trabajo",
    "Client portal templates": "Plantillas del portal del cliente",
    "Jobs": "Empleos",
    "Workflows": "Flujos de trabajo",
    "Company workflows": "Flujos de trabajo de la empresa",
    "Default workflows": "Flujos de trabajo predeterminados",
    "Company template saved": "Plantilla de empresa guardada",
    "Company template created": "Plantilla de empresa creada",
    "Format": "Formato",
    "Currency": "Moneda",
    "Reference number": "Número de Referencia",
    "Invoice description": "Descripción de la factura",
    "Summarize invoice rows": "Resumir líneas de facturas",
    "Summarized description": "Descripción resumida",
    "Reverse charge": "Revertir Cargo",
    "Rounding": "Redondear",
    "Time rounding will apply for each line": "Se aplicará el redondeo de tiempo para cada línea",
    "Rounding increment (up)": "Incremento de redondeo (hacia arriba)",
    "Reply to": "Contestar a",
    "Configuration": "Configuración",
    "Invoice to parent company": "Factura a la empresa matriz",
    "Create all invoices under parent company.": "Cree todas las facturas bajo la empresa matriz.",
    "User code": "Codigo de usuario",
    "Default": "Por defecto",
    "Default value will apply for each line": "El valor por defecto se aplicará a cada línea",
    "Number": "Número",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Puede escribir cualquiera de los siguientes datos entre llaves en el campo prefijo de la factura. Al guardar el contrato, el prefijo se rellena con el valor correspondiente.",
    "Copy to clipboard": "Copiar al portapapeles",
    "Invoice previous period": "Factura periodo anterior",
    "Invoice period": "Período de la factura",
    "Invoice next period": "Facturar el próximo periodo",
    "Client primary user": "Usuario principal del cliente",
    "Original client name": "Nombre del cliente original",
    "invoice date year": "fecha de factura año",
    "last two digits of invoice date year": "dos últimos dígitos de la fecha de facturación año",
    "invoice date month": "fecha de factura mes",
    "invoice date day": "fecha de factura día",
    "Contract": "Contrato",
    "Net total": "Total neto",
    "Contract #": "Contrato #",
    "Invoice #": "Factura #",
    "Exported": "Exportado",
    "Sent": "Enviado",
    "Net": "Neto",
    "Add invoice": "Añadir factura",
    "Change invoice number": "Cambiar el número de factura",
    "Review changes": "Revisar cambios",
    "Please review and approve changes to the related events": "Por favor, revise y apruebe los cambios en los eventos relacionados",
    "Please review and approve changes to the related projects": "Por favor, revise y apruebe los cambios en los proyectos relacionados",
    "Contains": "Contiene",
    "contains": "contiene",
    "Exactly": "Exactamente",
    "is exactly": "es exactamente",
    "Greater than": "Mayor que",
    "is greater than": "si es mayor que",
    "Less than": "Menos de",
    "is less than": "es menor que",
    "Range": "Rango",
    "is in range of": "está en el rango de",
    "is empty": "está vacía",
    "Task plan": "Plan de tareas",
    "Edit plan": "Editar plan",
    "Use task plan templates to set up tasks effectively or add a task manually": "Utilice plantillas de planes de tareas para configurarlas eficazmente o añada una tarea manualmente",
    "Add task manually": "Añadir tarea manualmente",
    "Quarterly": "Trimestral",
    "Export excel": "Exportar excel",
    "Print PDF": "Imprimir PDF",
    "Edit jobs": "Editar trabajos",
    "Replace plan tasks with job": "Sustituir las tareas del plan por el trabajo",
    "Select template": "Selecciona plantilla",
    "member": "miembro",
    "Tasks with user will be added to every selected client": "Las tareas con usuario se añadirán a cada cliente seleccionado",
    "Add even if job already applied": "Añadir aunque el trabajo ya se haya solicitado",
    "Default user": "Usuario predeterminado",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Esto eliminará todas las tareas del plan del cliente y pondrá en él sólo las tareas de la plantilla seleccionada",
    "Adding template will be ready in a minute. You can continue with work.": "Añadir plantilla estará listo en un minuto. Puede continuar con el trabajo.",
    "Add client": "Añadir cliente",
    "Export clients": "Exportar clientes",
    "Export client contacts": "Exportar contactos de clientes",
    "client | clients": "cliente | clientes",
    "clients": "clientes",
    "client(s) had errors": "cliente(s) tenía(n) errores",
    "client(s) selected": "cliente(s) seleccionado(s)",
    "Contract actions": "Acciones contractuales",
    "Edit Members": "Editar miembros",
    "Edit monitoring": "Editar supervisión",
    "Your company": "Sua empresa",
    "Edit billing": "Editar facturación",
    "Activate client portal": "Activar el portal del cliente",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Tras la activación, podrá enviar tareas directamente a todos los contactos del cliente que dispongan de una dirección de correo electrónico.",
    "Send welcome invitation to client contacts": "Enviar invitación de bienvenida a los contactos del cliente",
    "Who will receive an invitation?": "¿Quién recibirá una invitación?",
    "Client contact who has one valid e-mail address": "Contacto cliente que tiene una dirección de correo electrónico válida",
    "Client contact who has the client's portal open (default for all)": "Contacto del cliente que tiene abierto el portal del cliente (por defecto para todos)",
    "How does the invitation work?": "¿Cómo funciona la invitación?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku crea y envía una 'Tarea de bienvenida' a cada contacto del cliente. La crea el usuario principal del cliente basándose en la plantilla de tarea 'Bienvenido al portal del cliente'. Compruébelo en las plantillas de tareas de su empresa. Se traducirá según el idioma del contacto.",
    "Uku client portal always informs clients by email about new tasks.": "El portal de clientes Uku siempre informa a los clientes por correo electrónico sobre las nuevas tareas.",
    "View templates": "Ver plantillas",
    "Client portal activated": "Portal del cliente activado",
    "Company's name": "Nombre de la empresa",
    "Mark": "Marca",
    "Add members": "Añadir miembros",
    "Members and groups": "Miembros y grupos",
    "Topic is required": "El tema es obligatorio",
    "Entering time is required": "Es necesario introducir la hora",
    "Delete client": "Borrar cliente",
    "Manage client fields": "Gestionar los campos del cliente",
    "Max 3 characters": "Máximo 3 caracteres",
    "Are you sure you wish to delete this client?": "¿Está seguro de que desea eliminar este cliente?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Al borrar los datos del cliente también se borrarán todas las tareas relacionadas con el cliente.<br/><br/>¡NB! Se borrará el historial del cliente",
    "Owner": "Propietario",
    "All clients that you add under {0} will be deleted later.</div>": "Todos los clientes que añada en {0} se eliminarán posteriormente.</div>",
    "Use this account for testing purposes only!": "Utilice esta cuenta sólo con fines de prueba",
    "Read more about the demo account": "Más información sobre la cuenta de demostración",
    "Rights": "Derechos",
    "Monitoring setup": "Configuración de la monitorización",
    "Learn more about monitoring": "Más información sobre la vigilancia",
    "selected": "seleccionado",
    "Resend": "Reenviar",
    "Invoicing": "Facturación",
    "Billing template": "Plantilla de facturación",
    "New": "Nuevo",
    "Add row": "Añadir fila",
    "Delete contract": "Borrar contrato",
    "Product / description": "Producto / descripción",
    "Qty": "Cantidad",
    "Product placeholders": "Marcadores de posición de productos",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "Puede escribir cualquiera de las siguientes líneas entre llaves en la descripción del producto. Al guardar una factura sustituirá el texto por el valor correspondiente.",
    "Template saved": "Plantilla guardada",
    "Warning": "Advertencia",
    "Would you like to apply these changes to all clients using this contract template?": "¿Desea aplicar estos cambios a todos los clientes que utilicen este modelo de contrato?",
    "Yes, apply to all clients": "Sí, se aplica a todos los clientes",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Ha realizado cambios en el periodo de tiempo al que se aplica este contrato de facturación. Esto puede cambiar la forma en que se facturarán los servicios no facturados afectados en el pasado y en el futuro. Por favor, confirme que este cambio ha sido intencionado.",
    "Are you sure to delete this template?": "¿Está seguro de eliminar esta plantilla?",
    "Save template": "Guardar plantilla",
    "Save as template": "Guardar como plantilla",
    "Please note all changes made to contract will be lost": "Tenga en cuenta que todos los cambios realizados en el contrato se perderán",
    "Add contract": "Añadir controto",
    "Manage contract templates": "Gestionar plantillas de contratos",
    "Edit account details": "Editar detalles de la cuenta",
    "Country is required": "El país es obligatorio",
    "Postal code": "Código postal",
    "State": "Estado",
    "Uku is set up according to the field of work.": "Uku se establece en función del ámbito de trabajo.",
    "Size of the team": "Tamaño del equipo",
    "Website": "Sitio web",
    "Delete account": "Borrar cuenta",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Al eliminar una cuenta también se eliminarán todos los clientes asociados a la misma, sus tareas y todo su historial. ¿Está seguro de que desea eliminar su cuenta?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Sí, elimine la cuenta con todos los datos relacionados como clientes, tareas y todo el historial",
    "These invoices cannot be sent. Check their status or error messages.": "Estas facturas no pueden enviarse. Compruebe su estado o los mensajes de error.",
    "Please confirm that you wish to proceed.": "Por favor, confirme que desea continuar.",
    "Sending invoice | Sending invoices": "Envío de facturas | Envío de facturas",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Está a punto de enviar por correo electrónico esta factura al cliente. | Está a punto de enviar por correo electrónico estas facturas a los clientes.",
    "Error in calculating invoice": "Error en el cálculo de la factura",
    "Error in importing invoice": "Error al importar la factura",
    "Error in creating invoice": "Error al crear la factura",
    "Error in exporting invoice": "Error al exportar la factura",
    "Error in sending invoice": "Error en el envío de la factura",
    "Calculating invoice": "Cálculo de la factura",
    "Creating invoice": "Crear factura",
    "Exporting invoice": "Exportar factura",
    "Importing invoice": "Importar factura",
    "Sending invoice": "Envío de la factura",
    "Clear errors": "Borrar errores",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "El trabajo relacionado volverá a ser facturable. Las facturas no se eliminarán de los sistemas externos, tendrá que hacerlo manualmente.",
    "Delete invoice | Deleting invoices": "Borrar factura | Borrar facturas",
    "Selected net total": "Total neto seleccionado",
    "Nothing in invoices": "Nada en las facturas",
    "Please make sure you have setup recurring billing for your clients": "Asegúrese de haber configurado la facturación recurrente para sus clientes",
    "Draft": "Borrador",
    "Approval": "Aprobación",
    "Created": "Creado",
    "Coming soon": "Próximamente",
    "Selected invoices and related product info will be sent to accounting system.": "Las facturas seleccionadas y la información sobre los productos relacionados se enviarán al sistema contable.",
    "Piece": "Pieza",
    "Hour": "Hora",
    "Delete row": "Borrar fila",
    "Out of ": "Fuera de",
    " can be created": " se puede crear",
    "For ": "Para ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " el periodo de facturación sigue en curso. Cualquier trabajo realizado en este periodo después de la creación de la factura no será facturado.",
    "Invoice date will be set to today.": "La fecha de facturación se fijará en hoy.",
    "Uku is about to create": "Uku está a punto de crear",
    " selected row, only | selected row, only ": " fila seleccionada, sólo | fila seleccionada, sólo",
    " invoice | invoices": " factura | facturas",
    "These invoices cannot be exported. Check their status or error messages.": "Estas facturas no pueden exportarse. Compruebe su estado o los mensajes de error.",
    "Exporting invoice | Exporting invoices": "Exportar factura | Exportar facturas",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Está a punto de exportar esta factura a contabilidad. | Está a punto de exportar estas facturas a contabilidad.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "Esta factura ya ha sido exportada. ¿Está seguro de que desea exportarla como una nueva factura? | Algunas de estas facturas ya han sido exportadas. ¿Está seguro de que desea exportarlas como nuevas facturas?",
    "Download pdf": "Descargar PDF",
    "Create invoice": "Crear factura",
    "Update status from {0}": "Actualizar estado desde {0}",
    "Show all lines": "Mostrar todas las líneas",
    "Calculate invoice": "Calcular la factura",
    "Loading invoice...": "Cargando factura...",
    "Invalid Scoro credentials": "Credenciales de Scoro no válidas",
    "Please confirm the changes you have made to this invoice.": "Por favor, confirme los cambios que ha realizado en esta factura.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "¡NB! Tenga en cuenta que la factura modificada no se enviará automáticamente al cliente ni se exportará a sistemas externos; deberá hacerlo manualmente.",
    "Invoice number already exists! Please confirm to save anyway.": "¡El número de factura ya existe! Por favor, confirme para guardar de todos modos.",
    "Error in data": "Error en los datos",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "El periodo de facturación sigue en curso. Cualquier trabajo realizado en este periodo después de la creación de la factura no será facturado.",
    "Creation date": "Fecha de creacion",
    "{0} days after": "{0} días después",
    "{0} day after": "{0} día después",
    "right away when": "inmediatamente cuando",
    "start date": "fecha de inicio",
    "due date": "fecha límite",
    "finished": "finalizado",
    "Entries count": "Recuento de entradas",
    "Entries excluding sales": "Entradas excluidas las ventas",
    "Entries excluding bank": "Entradas sin banco",
    "Entries excluding documents": "Entradas excluidos los documentos",
    "Documents (sales and purchases)": "Documentos (ventas y compras)",
    "Cash entries": "Entradas de caja",
    "VAT entries": "Entradas de IVA",
    "Stock entries": "Entradas en existencias",
    "Sale entries": "Entradas en venta",
    "Purchase entries": "Entradas de compra",
    "Bank entries": "Anotaciones bancarias",
    "Ledger entries": "Asientos contables",
    "Depreciation entries": "Entradas de amortización",
    "Entry lines count": "Recuento de líneas de entrada",
    "Transaction create": "Transacción crear",
    "Transaction update": "Actualización de transacciones",
    "Purchase invoice create": "Crear factura de compra",
    "Purchase invoice update": "Actualización de factura de compra",
    "Sales invoice create": "Crear factura de venta",
    "Sales invoice update": "Actualización de factura de venta",
    "Financial entry create": "Crear entrada financiera",
    "Financial entry update": "Actualización de la entrada financiera",
    "Expense row create": "Crear fila de gastos",
    "Expense row update": "Actualización de la fila de gastos",
    "Depreciation create": "La depreciación crea",
    "Depreciation update": "Actualización de la depreciación",
    "Person count": "Recuento de personas",
    "Fixed assets": "Activos fijos",
    "Company owner": "Propietario de la empresa",
    "Activity": "Actividad",
    "Oldest first": "Antiguos primero",
    "Newest first": "Más Recientes",
    "Quantity as time": "Cantidad como tiempo",
    "Quantity as number": "Cantidad como número",
    "Quantity as time in number format": "Cantidad como tiempo en formato numérico",
    "No rounding": "Sin redondeo",
    "min": "min",
    "hour": "hora",
    "Last day of month": "Último día del mes",
    "Invoice line": "Línea de factura",
    "Task time total (per member)": "Tiempo total de la tarea (por miembro)",
    "Time entry": "Entrada de tiempo",
    "Task finish date": "Fecha de finalización de la tarea",
    "Create separately": "Crear por separado",
    "Merge into one": "Fusionar en uno",
    "No minimum": "Sin mínimo",
    "{0} minute": "{0} minuto",
    "{0} minutes": "{0} minutos",
    "{0} hour": "{0} hora",
    "{0} hours": "{0} horas",
    "English": "Inglés",
    "Estonian": "Estonio",
    "Danish": "Danés",
    "Lithuanian": "Lituano",
    "Russian": "Ruso",
    "Finnish": "Finlandés",
    "Swedish": "Sueco",
    "Norwegian": "Noruego",
    "Latvian": "Laton",
    "Bulgarian": "Búlgaro",
    "German": "Alemán",
    "Spanish": "Español",
    "Polish": "Polaco",
    "Field: ": "Campo:",
    "Normal hours": "Horario normal",
    "Year": "Año",
    "Estonia": "Estonia",
    "Finland": "Finlandia",
    "Poland": "Polonia",
    "User": "Usuario",
    "None": "Ninguno",
    "Error!": "Error!",
    "Pending": "Pendiente",
    "Finished": "Finalizado",
    "Text": "Texto",
    "Choice": "Elección",
    "Yes/No": "Si/No",
    "Integer": "Entero",
    "Multiple choice": "Opción múltiple",
    "URL": "URL",
    "Multiple users": "Multiples usuarios",
    "Multiline text": "Texto multilínea",
    "Must be a integer": "Debe ser un número entero",
    "Must be a date": "Debe ser una fecha",
    "Must be a valid e-mail address": "Debe ser una dirección de e-mail válida",
    "Unknown choice": "Elección desconocida",
    "Some errors occurred:": "Se han producido algunos errores:",
    "Unknown network error": "Error de red desconocido",
    "Could not connect to the service": "No se pudo conectar al servicio",
    "Reload this page": "Cargar de nuevo esta página",
    "Invoice paid": "Factura pagada",
    "Annulled": "Anulado",
    "Processing": "Procesando",
    "You are about to deactivate this app.": "Está a punto de desactivar esta aplicación.",
    "You are about to disconnect this app.": "Está a punto de desconectar esta aplicación.",
    "Do you also want to activate billing to get the most out of Uku?": "¿Quiere activar también la facturación para sacar el máximo partido a Uku?",
    "Invoice": "Factura",
    "Clients - Monitoring": "Clientes - Supervisión",
    "Links": "Enlaces",
    "New template": "Nueva plantilla",
    "Import Clients from Excel": "Importar clientes desde Excel",
    "Importer": "Importador",
    "Import clients from Excel": "Importar clientes desde Excel",
    "Account settings": "Configuraciones de la cuenta",
    "Empty": "Vacío",
};
export default translations